export const translationKOR = {
  privacyPolicy: {
    header: '개인정보 처리방침',
    downloadButton: '개인정보 처리방침 다운로드',
    subheader: '아래의 개인정보 처리방침을 검토하십시오.',
    content: {
      '1': {
        question: "1. '당사'란?",
        paragraph1: '어떤 제품 및 서비스에 대해서든 다음 연락처로 당사에 문의하실 수 있습니다.',
        paragraph2: 'EU 및 영국 정보보호책임자: 80 Strand, London, WC2R 0RL',
        paragraph3:
          'EU 담당자: Pearson Deutschland GmbH, Kaiserstraße 44, 60329 Frankfurt am Main, Germany',
        paragraph4Part1: '귀하는 ',
        paragraph4Link: 'dataprivacy@pearson.com',
        paragraph4Part2: '으로 이메일을 보내실 수도 있습니다.',
        paragraph5:
          '관련 제품 또는 서비스에 대한 특정 "개인정보처리자"는 해당 제품 또는 서비스에 대한 이용 약관에 설명되어 있습니다. 영국과 유럽의 제품 및 서비스의 경우 Pearson Education Limited 또는 Pearson UK Limited일 가능성이 높습니다.'
      },
      '2': {
        question: '2. 당사가 수집하는 개인정보',
        paragraph1:
          '이는 일반적으로 제품 또는 서비스에 따라 달라지므로 해당 제품 및 서비스 내에서 액세스할 수 있는 적시 알림 및 FAQ를 확인하시기 바랍니다.',
        paragraph2:
          '귀하에게 특별히 알려드리고 싶은 몇 가지 활동이 있습니다(그리고 이러한 처리 활동이 관련성이 있는 경우 알려 드리겠습니다). 당사가 수집하는 개인정보 항목은 다음과 같습니다.',
        bullet1:
          '당사는 계정 설정에 사용하는 등록 정보(예: 이름(및 선호하는 이름), 국가, 도시, 생년월일, 이메일 주소, 사용자명 및 비밀번호)를 수집합니다. 귀하가 18세 이상의 개인인 경우 당사는 제품 또는 서비스 구매와 관련된 정보(예: 우편 주소, 전화번호 및 결제 정보)도 수집합니다. 이 정보는 당사가 계약을 이행하는 데 필수적인 정보입니다. 성별, 모국어 등 추가 선택적 등록 정보가 제공될 수 있으며 귀하가 제품 또는 서비스에 가입한 이유를 수집할 수도 있습니다. 이 모든 정보는 집계된 설문 조사 목적으로 제공됩니다.',
        bullet2:
          '당사는 선호도, 대화형 연습에 대한 응답, 평가 활동 및 결과, 성적 또는 점수와 같이 귀하가 당사의 제품 서비스를 사용하는 과정에서 생성되는 활동 및 사용 정보를 수집합니다. 귀하는 제품 또는 서비스와 관련된 인증서 발급에 사용되는 프로필 사진을 업로드할 수도 있습니다.',
        bullet3:
          '당사는 귀하의 이름, 사진 및 만료일을 추출하기 위해 귀하가 업로드하는 정부 발급 신분증(예: 여권/운전면허증)을 수집합니다. ID의 진위를 확인하기 위해 요구되는 셀카 사진과 비교하며, 프로필 생성 시 당사에 제공하는 이름 및 프로필 사진과 일치하도록 요구됩니다. 인공지능을 사용하는 얼굴 매칭 기술에 의존하여 사진이 일치하는지 확인하며, 불일치가 발견되면 Pearson의 인간 검토자 팀과 공유됩니다(서비스에 대한 귀하의 액세스가 자동으로 거부되지 않도록 하기 위함).',
        bullet4:
          '당사는 귀하의 영상 녹화, 사진, 음성 응답 및 시험 중에 녹음된 배경 소음을 통해 "특별 범주 데이터"를 수집합니다. 당사는 귀하가 점수를 받을 수 있도록 귀하의 응답을 수집하고, 또한 올바른 사람이 시험에 응시하고 있는지 확인하고 부정행위가 없는지 감독하기 위해 이 작업을 수행합니다. 여기에는 서비스 공급업체가 제공하는 인공지능을 사용한 얼굴 및 음성 매칭 기술의 사용이 포함되며, 당사는 시험 응답이 당사 파일에 있는 참조 음성 및 사진과 일치하는지 확인하고 시험 중에 발생하는 부정행위 "플래그"가 없는지 확인합니다. 이 기술은 실시간으로 감시하지 않으며, 플래그는 시험 중 얼굴 움직임과 같은 감정적 행동은 추적하지 않지만, 객관적으로 사전에 정해진 기준에 따라 당사가 보관하는 파일상 데이터와 녹음이 일치하는지 추적합니다. Pearson의 인간 검토자는 ID의 불일치 및/또는 잠재적 부정행위가 확인된 경우 이를 검토할 것이며, 이러한 경우 당사는 시험 완료 인증서를 발급하지 않고 (i) 무료 재시험을 제공하거나, (ii) 부정행위가 명백히 발생했으며 인간 검토자를 통해 확인된 경우에는 귀하의 계정을 정지할 수 있습니다. 귀하는 계정 정지에 대해 항의할 권리가 있으며, 보안 요건 및 정책은 당사 웹사이트를 참고하시기 바랍니다.',
        bullet5:
          '당사는 귀하의 사진과 모의고사 중 음성 응답 및 배경 소음을 녹음하여 귀하가 시험을 완료하고 점수를 받을 수 있도록 하고 당사가 모의고사 중에 시험 환경을 완벽하게 시뮬레이션할 수 있도록 합니다. 이러한 모의고사 중에는 위에서 언급한 기술을 사용하여 귀하의 신원을 확인하거나 부정행위 플래그를 식별하지 않습니다.',
        bullet6:
          '당사는 귀하가 로그인하는 국가를 기준으로 귀하에게 관련 콘텐츠를 제공하기 위해 위치 정보(IP 주소 포함)를 수집합니다. 또한 귀하의 필요에 보다 적합한 맞춤형 콘텐츠를 제공하기 위해 기타 장치 및 쿠키 정보(법률에서 요구하는 경우 귀하의 동의를 받음), 로그인 데이터 및 장치 정보를 수집합니다. 자세한 내용은 제품 또는 서비스에 액세스할 때 접근 가능한 쿠키 정책을 참고하시기 바랍니다.',
        paragraph3:
          '당사가 시험 중 매칭 확인을 위해 서비스 공급업체의 인공지능 기술을 사용하는 경우, 서비스 공급업체는 기술 개선을 위해 귀하에 대해 수집된 개인정보를 사용할 수 있습니다. 이러한 활동이 이루어지는 경우에는 해당 내용이 안내될 것이며, 해당 서비스 제공업체의 개인정보 취급방침의 적용을 받으므로 당사는 해당 개인정보 취급방침을 링크합니다.'
      },
      '3': {
        question: '3. 당사의 개인정보 수집 목적 및 법적 근거',
        paragraph1:
          '궁극적으로, 당사는 당사의 제품 및 서비스를 사용하여 귀하의 학습 일생을 추적하는 데 도움이 되도록 가능한 최상의 경험을 제공하기 위한 목적으로 개인정보를 수집합니다. 즉, 계정 등록을 용이하게 하고, 귀하와 커뮤니케이션하고, 시장 조사 및 서비스를 개선하고, 귀하의 경험을 개인화하고, 제3자 기술과의 통합을 관리하고, 법과 규정을 준수하고 당사의 법적 권리를 보호하고 행사하는 것이 목적입니다. 이를 위한 당사의 근거는 다음과 같습니다.',
        bullet1: '계약 이행(예: 귀하가 구매하거나 액세스한 제품/서비스 제공을 위해 수집)',
        bullet2:
          '언제든지 철회할 수 있는 귀하의 동의(예: 귀하가 18세 이상인 경우, 마케팅 활동을 위해 수집)',
        bullet3:
          '당사의 법적 의무 준수(예: 정보를 보고하거나 공유해야 하는 규제 의무가 있을 수 있음)',
        bullet4:
          '교육 제품 및 서비스의 상업적 제공자로서 당사의 합법적인 이익에 부합하는 다양한 비즈니스 목적(적시 통지를 통해 서비스별로 자세히 설명됨)',
        paragraph2:
          '민감한/특별한 범주의 개인정보(예: 생체인식정보 또는 건강정보)를 처리하는 경우, 이는 상당한 공공 이익(사기 또는 부정행위 방지)을 기반으로 하거나 추구하는 목적 또는 사용자의 동의에 적합한 법적 기반을 기초로 하는 추가적인 법적 근거가 필요합니다.'
      },
      '4': {
        question: '4. 당사가 정보를 수집하는 경우',
        paragraph1: '당사는 다음과 같은 세 가지 주요 방법으로 귀하의 정보를 수집합니다.',
        bullet1:
          '귀하(또는 귀하의 부모/보호자)가 직접 정보를 제공하는 경우. 예: 제품 또는 서비스 사용을 위해 등록하거나, 당사에 연락(온라인 또는 오프라인)하거나, 당사 제품 및 서비스에 대한 구독을 구매하는 경우.',
        bullet2: '귀하가 직접 제품 또는 서비스와 상호작용하거나 당사의 이메일로 연락하는 경우.',
        bullet3:
          '특정 제3자로부터 간접적으로 수집하는 경우. 이는 제품 또는 서비스에 따라 다르므로 사용자 여정의 구체적인 설명을 참고하시기 바랍니다. 여기에는 학교/유사 기관으로부터의 정보가 포함됩니다(귀하가 당사 제품 또는 서비스에 액세스하기 위한 학교 액세스 코드를 가지고 있는 경우). 또한 인증 목적으로 Google 계정을 사용하여 등록하는 경우 Google의 정보도 포함됩니다. 당사는 우편 주소 또는 신용카드 정보의 유효성 검사와 같이 당사가 수집하는 정보를 업데이트, 확인 또는 추가할 수 있도록 제3자로부터 귀하의 정보를 입수할 수도 있습니다.',
        paragraph2:
          '참고: 일부 제품 및 서비스는 어린이를 위해 제공됩니다(18세 미만의 개인으로 정의). 이 경우, 당사는 어린이가 쉽게 이해할 수 있는 방식으로 당사의 정보처리에 대한 정보를 제시하거나, 부모/보호자가 해당 아동 대신 등록하는 경우 관련 사항을 설명해 줄 것을 요청합니다.'
      },
      '5': {
        question: '5. 귀하의 개인정보 또는 개인식별정보 보유기간',
        paragraph1:
          '당사는 귀하의 개인정보를 처리하는 목적을 달성하기 위해 합리적으로 필요한 기간 동안 귀하의 정보를 보유합니다. 이는 귀하가 당사의 제품 및 서비스를 사용하는 전체 기간 및 그 이후 합리적인 기간 동안일 수 있습니다(일반적으로 1년 정도 비활성 상태가 지속되면 당사는 사용자에게 추가 활동이 없을 경우 6개월 후에 계정이 삭제된다는 이메일을 보냅니다). 시험 완료 후 6개월 동안 특정 사진과 오디오를 저장하는 등 상대적으로 짧은 기간 동안 보유할 수도 있습니다. 청구서 및 특정 지급 정보는 해당 청구서가 발행된 회계연도를 포함한 6년의 기간 동안 보유하는 등 법률상 더 오래 보유하도록 요구되는 경우에는 그에 따릅니다. 보유기간은 제품 또는 서비스에 따라 달라지므로 해당 제품 및 서비스 내에서 액세스할 수 있는 FAQ를 참고하시기 바랍니다.',
        paragraph2:
          '당사는 가능한 경우 학습자 유형 또는 제품 및 서비스 사용 방법 분석, 전략적 개발 지원, 교육 연구 수행, 새로운 제품 및 서비스 개발 및 기존 서비스 개선을 위해 (직접 또는 간접적으로 개별 학습자가 식별되지 않도록) 개인정보를 익명화합니다.'
      },
      '6': {
        question: '6. 공개 및 이전',
        paragraph1: '그룹사에 공개',
        paragraph2:
          '당사는 당사 제품 및 서비스에 대한 새로운 기능을 분석, 시험 및 개발하기 위해 Pearson 그룹 내의 다른 회사에 귀하의 개인정보 또는 개인식별정보를 공개할 수 있습니다. 또한, Pearson 그룹이 귀하가 관심을 가질만한 관련 제품 및 서비스를 제안할 수 있도록 귀하의 동의(법률에서 요구하는 경우) 하에 귀하의 개인정보를 그룹에 공유할 수도 있습니다.',
        paragraph3: '사업체, 파트너 및 수탁기관에 공개',
        paragraph4:
          '특정 제품 및 서비스의 경우, 당사는 직원 및 학습자가 서비스를 이용할 수 있도록 하는 고용주 및 교육 기관과 긴밀히 협력합니다. 이들은 개인정보처리자로서 개인정보 처리에 관한 자체 개인정보 처리방침이 있을 수 있으므로, 이를 요청하여 읽어보시기 바랍니다.',
        paragraph5: '기타 공개 사항',
        paragraph6: '당사는 다음과 같은 경우 개인정보 또는 개인식별정보를 공개할 수 있습니다.',
        bullet1:
          '데이터 센터, 웹 호스트, 클라우드 스토리지 및 클라우드 소프트웨어 제공자, 고객 지원 서비스 제공자, 결제 처리자, 채권 추심자, 회계사, 보험사 등의 외부 공급업체 및 정보처리자와 공유하는 경우',
        bullet2:
          '당사가 재정적 어려움을 겪는 등 당사 사업 또는 자산의 잠재적 매도인 또는 매수인(및 각각의 전문 자문인)과 투자자 및 당사의 전문 자문인과 공유하는 경우',
        bullet3:
          '18세 미만의 학습자를 대신하여 제품 또는 서비스에 대한 액세스를 구매한 부모/보호자와 공유하는 경우',
        bullet4:
          '귀하가 당사에 동의하거나 당사에 귀하의 정보 공유를 요청하는 경우(예: 평가 피드백을 제공할 수 있도록 시험 완료를 확인하는 인증서를 고용주 및/또는 기관 또는 일부 가상의 교실로 보냄. 사용자는 이러한 정보 공유를 언제든지 취소할 수 있음.)',
        bullet5:
          '당사가 집행 조치, 법률 또는 계약상의 준수 및 보고 목적을 위해 규제 기관, 법 집행 기관, 법원 및 기타 관련 당사자와 공유하도록 요구 또는 요청받은 경우. 또한 당사의 이용 약관을 집행하고, 귀하 및 다른 학습자의 안전을 보장하며, 당사 및 제3자의 권리와 재산을 보호하기 위해 공유하는 경우',
        paragraph7: '개인정보 이전',
        paragraph8:
          '당사는 글로벌 조직의 일부로서 글로벌 서비스 공급업체를 사용합니다. 이에 따라 귀하가 거주하는 국가 이외의 국가에서 귀하의 정보가 처리되고 공유될 수 있지만, 당사는 현지 법률을 준수하고 정보수령자로 하여금 관련 정보보호법에서 요구하는 것과 동일한 보호 기준을 보장하도록 하는 적절한 조치가 있는 경우에만 정보를 국외로 이전합니다.',
        paragraph9:
          '귀하가 유럽연합 또는 영국 거주자인 경우, 당사는 (a) 여기에 열거된 개인정보(또는 영국에서 이에 상응하는 정보)에 대해 유럽연합 집행위원회가 적절한 수준의 보호를 제공하는 것으로 간주하는 국가에만, 및/또는 (b) 유럽연합 집행위원회 및 정보위원회가 승인한 개인정보 보호에 관한 특정 계약이 있는 경우에만 귀하의 개인정보를 이전합니다.'
      },
      '7': {
        question: '7. 귀하가 보유하는 권리',
        paragraph1:
          '귀하가 거주하는 국가에 따라, 귀하는 귀하의 개인정보와 관련하여 다른 권리를 가질 수 있습니다.',
        paragraph2:
          '귀하가 유럽연합 또는 영국 거주자인 경우, 귀하가 가질 수 있는 권리는 다음과 같습니다.',
        paragraph3:
          '처리에 반대할 권리. 귀하는 당사가 정당한 이익을 추구하는 경우 언제든지 귀하의 개인정보 처리에 반대할 수 있습니다. 귀하가 반대하는 경우, 당사는 귀하의 이익, 권리 및 자유에 우선하는 개인정보 처리에 대한 설득력 있고 정당한 근거를 입증할 수 있거나 법적 청구권의 설정, 행사 또는 방어를 위해 개인정보를 처리해야 하는 경우가 아닌 한 해당 처리를 중단해야 합니다. 당사가 처리의 근거로 정당한 이익에 의존하는 경우 당사는 설득력 있고 정당한 근거를 입증할 수 있다고 믿지만 각 사례별로 검토할 것입니다. 또한 귀하는 언제든지 직접 마케팅 목적으로 귀하의 개인정보를 처리하는 것에 반대할 수 있습니다. 귀하가 반대하는 경우 당사는 해당 처리를 중단합니다.',
        bullet1:
          '접근 권한. 귀하는 귀하의 개인정보 사본을 당사에 요청할 수 있습니다. 다만, 예외가 있어 귀하는 당사가 처리하는 모든 정보를 항상 제공받지 못할 수도 있습니다. 이러한 예외에는 요청된 정보가 제3자에 대한 개인정보를 포함하는 경우가 포함됩니다.',
        bullet2:
          '수정할 권리.귀하는 정확하지 않다고 생각되는 정보의 수정을 요청할 수 있습니다. 또한 귀하는 불완전하다고 생각되는 정보를 완성하도록 당사에 요청할 수 있습니다.',
        bullet3:
          '삭제할 권리.귀하는 특정 상황에서 귀하의 개인정보를 삭제하도록 당사에 요청할 수 있습니다.',
        bullet4:
          '처리를 제한할 권리.귀하는 특정 상황에서 귀하의 정보 처리를 제한하도록 당사에 요청할 수 있습니다.',
        bullet5:
          '동의를 철회할 권리.당사가 귀하의 개인정보를 처리하는 데 동의가 필요한 경우 귀하는 언제든지 이를 철회할 수 있습니다. 이는 귀하가 동의를 철회하기 전에 이루어진 처리의 적법성에 영향을 미치지 않습니다.',
        bullet6:
          '정보 이동성에 대한 권리.이는 귀하가 당사에 제공한 정보에만 적용됩니다. 귀하는 귀하가 당사에 제공한 정보를 한 기관에서 다른 기관으로 이전하거나 귀하에게 제공하도록 요청할 수 있습니다. 해당 권리는 당사가 계약 이행 및/또는 귀하의 동의에 따라 정보를 처리하는 경우에만 적용됩니다.',
        paragraph4:
          '귀하는 권리 행사에 대한 어떠한 비용도 지불할 필요가 없으나, 귀하의 요청이 근거가 없거나 반복적이거나 과도한 경우에는 당사가 합리적인 수수료를 부과할 수 있습니다. 당사는 귀하의 요청에 1개월 이내에 답변합니다(귀하가 여러 건의 요청을 하거나 귀하의 요청이 복잡한 경우에는 답변하는 데 최대 2개월이 추가로 소요될 수 있으나, 이 경우 귀하에게 미리 알려드립니다). 당사가 귀하에게 신원 확인을 요청하는 경우, 이를 수령할 때까지 1개월 기한은 시작되지 않습니다. 요청 범위에 대한 명확한 설명이 필요한 경우 당사가 해당 정보를 받을 때까지 1개월 기한이 일시 중지됩니다.',
        paragraph5:
          '또한 귀하는 현지 당국을 포함한 감독 기관에 언제든지 불만을 제기할 권리가 있습니다. 물론, 감독 기관에 연락하기 전에 당사에게 귀하의 우려사항을 처리할 수 있는 기회를 먼저 주시면 감사하겠습니다.',
        paragraph6:
          '캘리포니아 거주자는 본 개인정보 처리방침과 함께 캘리포니아 거주자의 개인정보에 대한 캘리포니아 법률을 준수하겠다는 당사의 약속을 설명하는 캘리포니아 거주자를 위한 추가 개인정보 처리방침도 참고하시기 바랍니다.'
      },
      '8': {
        question: '8. 본 개인정보 처리방침의 변경',
        paragraph1:
          '당사는 본 처리방침이나 특정 진술을 수시로 업데이트할 수 있습니다. 변경 사항이 언제 발생했는지 알 수 있도록 항상 새로운 버전의 날짜를 기재합니다. 중대한 변경 사항은 법률에 의해 요구되는 경우 귀하에게 통지할 것입니다.',
        paragraph2: '본 개인정보 처리방침은 2022년 12월 6일에 마지막으로 업데이트되었습니다.'
      },
      header: 'Pearson 온라인 제품 개인정보 처리방침',
      description:
        "본 개인정보 처리방침은 Pearson 그룹(Pearson Education, Inc, Pearson Education Limited 및 여기에 나열된 그룹사들)이 개인정보를 어떻게 이용하는지 설명합니다. 당사는 가능한 한 비즈니스 전반에 걸쳐 일관된 접근 방식을 취하고 있지만, 귀하가 사용하는 제품 및 서비스에 따라 수집 및 처리하는 개인정보가 다를 수 있습니다. 따라서 당사는 당사 제품 및 서비스의 사용자 여정에 개인정보 보호 내용을 포함시켰습니다(예: 개인정보 수집 시점의 \"적시 알림\"). 본 처리방침과 함께 읽어야 하며, 당사가 귀하의 '개인정보' 및 '개인식별정보'를 수집하고 이용하는 방법을 명확히 이해할 수 있을 것입니다. '개인식별정보'는 단독으로 또는 기타 개인정보와 함께 개인을 식별, 연락, 또는 위치를 파악하기 위해 사용될 수 있는 정보(예: 이름, 별명 또는 온라인 식별자)입니다."
    }
  },
  termsOfUse: {
    header: '이용 약관',
    downloadButton: '이용 약관 다운로드',
    subheader: '당사 일반 서비스 약관 및 최종 사용자 라이선스 계약 검토',
    preSection: {
      header: '일반 서비스 약관 및 최종 사용자 라이선스 계약',
      paragraph1:
        '"수락함" 또는 "동의함"을 클릭하거나 서비스를 사용함으로써 귀하는 본 일반 서비스 약관 및 최종 사용자 라이선스 계약("UTOS")을 체결하게 되며, 이는 Pearson Education, Inc. 및 그 계열사(총칭하여 "당사" 또는 "Pearson")의 이익을 위해 체결되는 구속력 있는 계약입니다.',
      paragraph2:
        'UTOS는 본 웹사이트 및 모든 관련 서비스의 사용에 대한 일반 조건을 명시합니다. 서비스에 액세스하거나 서비스를 사용함으로써 귀하는 UTOS의 조건에 동의하며 (1) 해당 조건을 읽고 이해했으며, (2) UTOS, 모든 해당 지역, 주, 국가 및 국제 법률 및 규정, 그리고 귀하의 기관의 학칙 또는 정책에 따라 서비스를 사용하는 데 동의하고, (3) 승인된 사용자라고 진술합니다. UTOS에 동의하지 않거나 승인된 사용자가 아닌 경우 귀하는 서비스를 사용할 수 없습니다. UTOS에 관한 궁금한 점은 <a target="_blank" href="https://pearson.tfaforms.net/3048">Pearson 지원 센터</a>로 문의해 주십시오.',
      paragraph3:
        '아래에 포함된 섹션 제목 및 기울임꼴로 표시된 요약은 귀하의 편의를 위한 것이며 법적 의미나 효력이 없습니다.'
    },
    content: {
      '1': {
        question: '1. 개인정보 보호, 수집 및 이용',
        paragraph1:
          '서비스를 위한 Pearson의 데이터 수집 및 이용 관행은 각 서비스에 적용되는 개인정보 처리방침에 설명되어 있습니다. 당사는 개인정보 처리방침 및 관련 법령에 따라 귀하의 개인 정보를 수집, 처리 및 이용합니다.'
      },
      '2': {
        question: '2. 당사의 UTOS의 조건을 수시로 변경해야 할 수 있습니다.',
        paragraph1:
          '당사는 수시로 UTOS의 규칙을 업데이트할 수 있습니다. 유의미한 변경이 있으면 알려드리겠습니다. 서비스를 계속 사용하면 업데이트된 규칙을 따르는 데 동의하는 것입니다.',
        paragraph2:
          'Pearson은 어떤 이유로든 UTOS를 수시로 변경할 수 있습니다. 일반적으로 이러한 변경은 현재의 관행을 준수하거나 변화하는 규제 요건을 준수하거나 기타 유사한 목적을 위해 이루어집니다. Pearson이 귀하에게 제공하는 서비스의 조건이나 범위를 실질적으로 변경하는 방식으로 UTOS를 수정하는 경우("서비스 변경"), 당사는 이메일을 통해 귀하에게 연락하거나 합리적인 공지를 게시하여 알리는 방식으로 귀하에게 서비스에 관한 변경 사항을 알리기 위한 합당한 노력을 기울일 것입니다. UTOS 변경에 대한 합리적인 통지가 제공된 후에도 서비스를 계속 사용하는 것은 개정된 UTOS 조건에 동의하는 것으로 간주되며, 개정된 UTOS는 합리적인 통지 후 모든 서비스 사용에 적용됩니다. 서비스 변경이 본인에게 중대한 영향을 미친다고 판단되는 경우, 귀하는 (1)그러한 변경 통지를 받은 후 30일 이내에 <a target="_blank" href="https://pearson.tfaforms.net/3048">Pearson 지원 센터</a>에 통지해야 하며, (2) 귀하의 구독 및 서비스 사용을 해지할 수 있습니다. UTOS에 관한 궁금한 점은 <a target="_blank" href="https://pearson.tfaforms.net/3048">Pearson 지원 센터</a>로 문의해 주십시오.'
      },
      '3': {
        question: '3. 서비스 사용 라이선스',
        paragraph1:
          '귀하는 구독이 종료될 때까지 개인적인 교육 목적(UTOS에서 허용하는 바에 따름)으로 서비스의 특징과 기능을 사용할 수 있습니다.',
        paragraph2:
          'Pearson은 UTOS, AUP, 해당 개인정보 처리방침 및 귀하의 기관 또는 제3자 서비스에 의해 설정될 수 있는 모든 추가 약관에 명시된 조건 및 제한 사항에 따라 의도된 목적으로 서비스를 사용할 수 있는 제한적이고, 양도 불가능하며, 비독점적이고, 재라이선스 불가능한 라이선스를 귀하에게 허여합니다.',
        paragraph3:
          '귀하는 서비스를 통해 획득한 자료를 개인적 및 비상업적 교육 목적으로만 사용 및 게시할 수 있으며, 이러한 기능을 서비스에서 사용할 수 있는 경우 형식 변경, 다운로드 및 인쇄할 수 있습니다.',
        paragraph4:
          '귀하는 서비스의 적절한 사용 및 액세스에 필요한 현행 하드웨어, 운영 체제, 인터넷 브라우저 및 기타 기술 요건을 충족할 책임이 있습니다. UTOS에서 명시적으로 부여되지 않은 모든 권리는 Pearson이 보유합니다. 귀하는 UTOS에 따라 허여된 라이선스가 귀하에게 서비스 또는 서비스에 포함된 자료에 대한 소유권을 제공하지 않으며, UTOS의 조건에 따라 제한된 사용 권한만 제공한다는 점을 인정합니다.'
      },
      '4': {
        question: '4. "서비스"의 의미',
        paragraph1:
          '"서비스"란 Pearson의 웹사이트, 디지털 제품 및 이를 지원하는 모든 것을 의미합니다. 이러한 서비스는 Pearson 또는 그 라이선스 제공자의 소유이지만, 당사는 귀하가 이러한 규칙에 따라 서비스를 사용하고 즐기기를 바랍니다.',
        paragraph2:
          '이 웹사이트 및 관련 애플리케이션, 제품, 서비스, 기술, 콘텐츠, 및 기타 지식재산(총칭하여 "서비스")은 Pearson 또는 그 라이선스 제공자가 소유하거나 라이선스를 허여합니다. 서비스를 통해 제공되는 모든 웹사이트, 강좌 자료 및 기타 콘텐츠(총칭하여 "자료") 및 지원 소프트웨어, 애플리케이션 및 시스템(총칭하여 "애플리케이션")은 Pearson 및/또는 해당 라이선스 제공자의 독점적 재산입니다. 서비스는 귀하의 브라우저 또는 앱(모바일 등)에서 인터넷을 통해 귀하에게 전달될 수 있으며, 귀하의 학교, 고용주, 대학 또는 기타 교육 기관("기관")에서 제공하는 수업 및 프로그램과 관련하여 서비스를 통해 제공되는 하나 이상의 온라인 강좌("강좌")에 등록("등록")하는 것을 포함할 수 있습니다. 귀하의 사용자 계정은 다른 강좌에 등록할 수 있는 동안 무기한 지속될 수 있지만, 서비스를 통해 제공되는 특정 강좌에 대한 액세스는 제한된 기간 동안 구독 방식으로 제공됩니다("구독"). 서비스는 Pearson이 직접 제공하거나 귀하의 기관 또는 통합 제3자 서비스 제공자가 관리하는 계정과의 제3자 통합을 통해 액세스할 수 있습니다("제3자 서비스"). 서비스는 제3자 웹사이트 또는 애플리케이션에 연결되거나 그에 액세스하는 옵션을 제공할 수 있습니다.'
      },
      '5': {
        question: '5. 서비스 사용 권한자',
        paragraph1:
          '특정 서비스를 사용하려면 Pearson 계정을 만들어야 합니다. 단, 대학생이 아닌 미성년자는 서비스를 위한 계정을 만들거나 직접 등록할 수 없습니다.',
        paragraph2:
          '서비스는 Pearson 또는 Pearson의 제3자 서비스 제공자로부터 직접 또는 해당 개인이 소속된 기관을 통해 서비스에 대한 합법적인 액세스 권한을 얻은 관리자 또는 기타 기관 대표자 및 학생을 포함하되 이에 국한되지 않는 개인("승인된 사용자")에게만 제공됩니다. 특정 서비스에 액세스하려면 이름과 유효한 이메일 주소(등록의 경우 기관 및 강좌 이름 또는 코드)를 제공하고 본인만 아는 고유한 사용자명과 비밀번호("계정 자격증명")를 지정하여 사용자 계정("사용자 계정")을 등록해야 하며, 기관이 요구하는 추가 정보를 제공해야 할 수도 있습니다. 경우에 따라 귀하의 사용자 계정은 귀하의 기관에서 이미 개설하였거나 학습 관리 시스템과 같은 통합 제3자 서비스에서 직접 액세스하는 방식으로 개설되었을 수 있으며, 각각의 경우 별도의 이용 조건 또는 계정 액세스 요건이 있을 수 있습니다. Pearson은 귀하가 서비스에 액세스할 때마다 서비스에 대한 액세스를 제공하기 전에 귀하의 계정 자격증명을 사용하여 귀하의 계정을 확인할 수 있습니다.',
        paragraph3:
          '귀하는 한 번에 하나의 활성 사용자 계정만 보유할 수 있습니다. 귀하는 사용자 계정을 생성할 때 정확하고 진실된 정보를 제공하고 해당 정보가 변경될 경우 즉시 업데이트하기로 동의합니다.',
        paragraph4:
          '귀하가 13세 미만인 경우, 부모 또는 법적 보호자가 귀하를 대신하여 계정을 개설하거나 등록하지 않는 한, 서비스에 직접 등록하거나 서비스에 액세스할 수 없습니다. 귀하가 관할 지역의 법률에 따라 성년 연령 미만인 경우(일반적으로 18세 미만), 부모 또는 보호자의 허가를 받지 않고 서비스를 등록하거나 사용할 수 없습니다. 부모 또는 법적 보호자가 귀하를 대신하여 미성년자로 사용자 계정을 등록하거나 설정하는 경우, 귀하가 해당 관할 지역에서 성년이 될 때까지 귀하를 대신하여 Pearson과 계약을 체결하게 되며, 귀하가 성년이 되는 시점에 계약이 귀하에게 이전됩니다. 그러나 귀하가 해당 연령 미만이고 고등 교육 기관에 재학 중인 경우에는 서비스에 직접 등록할 수 있습니다.',
        paragraph5:
          'Pearson은 단독 및 절대적 재량에 따라 사용자 계정을 일시 중단하거나 해지할 권리를 보유하며, 귀하가 UTOS 또는 <a target="_blank" href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html">AUP</a>를 위반할 경우 서비스를 사용하거나 액세스할 수 있는 귀하의 권리는 자동으로 해지됩니다. 또한 Pearson은 언제든지 서비스 또는 서비스의 일부를 일시적 또는 영구적으로 중단할 권리를 보유합니다.'
      },
      '6': {
        question: '6. 허용되는 서비스 사용',
        paragraph1:
          '서비스 사용은 Pearson의 <a target="_blank" href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html">허용 가능한 사용방침</a>("AUP")의 적용을 받습니다. 서비스에 액세스하거나 서비스를 사용함으로써 귀하는 AUP 조건을 준수할 것에 동의하게 됩니다. Pearson은 AUP의 조건을 위반하는 활동을 수행했거나 이에 참여했다고 Pearson이 합리적으로 판단하는 사용자 또는 Pearson, 서비스, 서비스 네트워크(AUP에 정의됨), 다른 사용자에게 피해를 입히거나 피해를 입힐 가능성이 있는 행위를 한 사용자에 대해, 또는 그 외의 이유로 Pearson의 단독 및 절대적 재량에 따라 서비스에 대한 액세스 및 사용을 일시 중단하거나 해지할 권리를 보유합니다. 또한 Pearson은 귀하의 기관의 요청에 따라 언제든지 귀하의 액세스를 일시 중단 또는 해지할 수 있습니다.'
      },
      '7': {
        question: '7. 계정 자격증명을 기밀로 안전하게 보관하십시오.',
        paragraph1:
          '귀하는 (1) 계정 자격증명을 기밀로 유지하고, (2) 다른 사람이 사용자 계정에 로그인하지 못하게 하고, (3) 다른 사람이 계정 자격증명을 보유하게 되면 당사에 알려야 합니다.',
        paragraph2:
          '귀하의 사용자 계정은 귀하의 개인적인 용도로만 사용됩니다. 당사가 그러한 사용에 대해 승인된 메커니즘을 제공하지 않는 한, 다른 사람이 귀하의 사용자 계정을 통해 서비스에 액세스하거나 서비스를 사용할 수 있도록 허용하는 것은 엄격히 금지되며, 귀하는 귀하의 사용자 계정과 관련된 귀하 또는 제3자의 모든 서비스 사용에 대해 책임이 있습니다.',
        paragraph3:
          '계정 자격증명 및 서비스의 보안을 위해서는 계정 자격증명의 기밀을 유지하는 것이 중요합니다. 귀하는 (1) 본인의 것이 아닌 계정 자격증명을 사용하거나 (2) 인증된 제3자 서비스 이외의 제3자 또는 서비스에 계정 자격증명을 공개하지 않을 것에 동의합니다. 귀하는 계정 자격증명의 기밀을 보호하기 위해 합리적인 조치를 취하고 계정 자격증명 및/또는 서비스와 관련하여 획득한 액세스 코드의 분실, 공개 또는 도난을 알게 되거나 의심되는 경우 즉시 <a target="_blank" href="https://pearson.tfaforms.net/3048">Pearson 지원 센터</a>에 알리는 데 동의합니다.'
      },
      '8': {
        question: '8. Pearson 또는 그 라이선스 제공자가 서비스를 소유합니다.',
        paragraph1:
          '서비스 및 모든 관련 지식재산권은 당사 또는 당사 라이선스 제공자의 소유이지만, 당사는 귀하가 UTOS에 설명된 대로 이를 사용하고 즐기기를 바랍니다.',
        paragraph2:
          '서비스를 통해 제공되는 모든 웹사이트, 강좌 자료 및 기타 콘텐츠(총칭하여 "자료") 및 지원 소프트웨어, 애플리케이션 및 시스템(총칭하여 "애플리케이션")은 Pearson 및/또는 그 라이선스 제공자의 독점적 재산이며, 미국 및 국제 저작권법 및 기타 지식재산권법의 보호를 받습니다. UTOS에 명시적으로 부여되지 않은 모든 권리는 Pearson 및 그 라이선스 제공자가 보유합니다. UTOS 또는 <a target="_blank" href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html">AUP</a>에 명시된 경우를 제외하고, Pearson 및/또는 그 라이선스 제공자의 명시적인 서면 동의 없이 자료 또는 애플리케이션의 전부 또는 일부를 복제, 재배포, 수정, 출판, 개조하는 행위는 엄격히 금지됩니다. 서비스에서 특정 자료를 복사 또는 다운로드할 수는 있지만, 이 기능을 사용할 수 있다고 해서 위의 제한 사항이 적용되지 않는다는 의미는 아닙니다.',
        paragraph3:
          '달리 명시되지 않는 한, 서비스에 표시되는 상표, 서비스 마크 및 상호명(총칭하여 "상표")은 Pearson 또는 그 라이선스 제공자의 자산입니다. 서비스에 표시된 Pearson 소유가 아닌 모든 상표는 각 상표권자의 자산입니다. 귀하는 서비스와 관련된 상표를 오용 또는 폄하하지 않으며, 상표의 소유권을 허위 표시하거나 제품 또는 서비스의 출처 또는 유래에 대해 대중에게 혼란을 줄 수 있는 방식으로 상표(또는 혼동을 일으킬 정도로 유사한 상표)를 사용하지 않을 것에 동의합니다. 귀하는 상표권자의 서면 동의 없이 상표를 사용할 수 없으며, 상표권자의 상표권에 대한 적절한 고지 및 귀속을 명시하고 각 상표권자가 제공한 해당 사용 가이드라인을 따라야 합니다. 귀하에게 허용된 상표의 사용은 해당 각 상표권자에게 이익이 되어야 합니다.'
      },
      '9': {
        question: '9. 사용자 제안은 Pearson이 소유합니다.',
        paragraph1:
          '귀하가 서비스를 개선할 수 있는 방법을 당사에 제안하는 경우, Pearson은 귀하의 제출물에 대한 모든 지식재산권을 소유하며 귀하의 아이디어를 보상 없이 사용할 수 있습니다.',
        paragraph2:
          'Pearson은 서비스에 대한 제안과 의견을 언제나 환영합니다. 귀하는 서비스, 온라인, 오프라인, 구두 또는 서면으로 Pearson에 제안하는 개선 사항, 추가 사항 또는 기타 의견("사용자 제안")을 제출할 수 있습니다. 귀하는 제출 방법과 관계없이 사용자 제안의 모든 권리, 소유권, 이익 및 기타 지식재산권(일본 저작권법 제27조 및 제28조에 명시된 권리를 포함하되 이에 국한되지 않음)이 Pearson의 독점 자산이 되며, 귀하에 대한 지급 또는 회계처리 없이 Pearson의 단독 및 절대적 재량에 따라 사업 목적으로 사용될 수 있음을 인정합니다. 이 방침은 Pearson이 개발한 제품 및 서비스가 타인의 사용자 제안과 유사한 것으로 보일 경우 향후 오해의 소지를 방지하기 위한 것입니다.'
      },
      '10': {
        question: '10. 귀하가 업로드한 콘텐츠를 당사가 이용하는 방법',
        paragraph1:
          '귀하가 서비스에 업로드한 모든 콘텐츠를 당사가 사용할 수 있으며(물론 해당 개인정보 처리방침, 관련 법령에 따름), 당사에 해당 권리를 부여할 권한이 있음에 동의합니다.',
        paragraph2:
          '본 서비스는 승인된 사용자가 질문, 응답, 의견, 아이디어, 기사, 정보, 데이터, 텍스트, 멀티미디어 콘텐츠, 채팅 대화 또는 로그, 메시지 및 기타 자료 또는 제출물("사용자 콘텐츠")을 생성, 업로드 또는 게시하는 기능을 제공할 수 있습니다. 귀하는 사용자 콘텐츠를 생성, 게시, 업로드 또는 링크함으로써 해당 사용자 콘텐츠 및 그로부터 생성된 2차적 저작물(예: 귀하의 사용자 콘텐츠가 서비스와 더 잘 작동하도록 당사가 변경한 결과물)을 서비스와 관련하여 사용, 호스팅, 라이선스, 저장, 복제, 표시, 전송, 개조 및 배포할 수 있는 영구적이고, 로열티가 면제되고, 전세계적인 권리 및 라이선스를 Pearson에게 허여합니다. 또한 귀하는 귀하의 사용자 콘텐츠가 UTOS 및 특히 본 섹션 10에 따라 귀하가 Pearson에게 승인한 것과 동일한 조건으로 다른 사용자에게 제공된다는 것을 인정하고 이에 동의합니다. Pearson은 사용자 콘텐츠의 삭제, 파기, 손상, 손실 또는 저장 실패에 대해 책임을 지지 않습니다. 단, 사용자 콘텐츠의 삭제, 파기, 손상, 손실 또는 저장 실패가 Pearson의 고의 또는 과실로 인해 발생한 경우에는 적용되지 않습니다. 귀하는 제3자 소유의 사용자 콘텐츠를 게시함으로써 서비스와 함께 제공된 자료와 동일한 범위 내에서 Pearson이 이러한 사용자 콘텐츠를 사용자에게 제공하도록 할 수 있는 권리를 부여 받았음을 나타냅니다. 귀하는 귀하 또는 제3자가 저작권을 주장하는 사용자 콘텐츠와 관련하여 적절한 저작권 통지를 제공하는 데 동의합니다. 추가 조건 및 옵션은 사용자 콘텐츠를 게시 또는 업로드하기 위해 서비스에서 사용할 수 있는 사용자 인터페이스를 통해 제시될 수 있으며, 이는 UTOS의 조건을 보완하고 동일한 효력을 가집니다.'
      },
      '11': {
        question: '11. 제3자 웹사이트 및 콘텐츠 액세스에 따른 위험은 사용자가 부담합니다.',
        paragraph1:
          '서비스가 귀하를 Pearson이 아닌 웹사이트 또는 서비스로 연결하거나 리디렉션하는 경우, 귀하는 자신의 위험 부담으로 해당 웹사이트 또는 서비스를 사용하는 것에 동의합니다.',
        paragraph2:
          '귀하는 제3자 웹사이트에서 서비스에 연결되었을 수 있으며, 서비스가 Pearson이 통제할 수 없는 다른 제3자 웹사이트 또는 리소스(총칭하여 "제3자 사이트")에 대한 링크를 제공할 수 있습니다. Pearson은 서비스에서 제3자 사이트로 연결되는 링크를 통해 액세스할 수 있는 제3자 콘텐츠("제3자 콘텐츠"), 서비스 또는 애플리케이션에 대해 책임을 지지 않습니다. Pearson은 제3자 사이트 또는 제3자 콘텐츠의 정확성, 무결성 또는 품질을 보장하거나 보증하지 않으며, 이러한 콘텐츠나 사이트에서 발생하는 오류, 누락, 제3자 권리 위반 또는 불법 행위에 대한 모든 책임을 부인합니다. 서비스에 제3자 사이트에 대한 링크가 포함되었다고 해서 해당 제3자 사이트의 소유자가 서비스를 후원하거나 보증했음을 의미하지는 않습니다. Pearson은 서비스의 링크를 통해 액세스하는 제3자 사이트의 가용성에 대해 책임을 지지 않으며, 이러한 제3자 사이트는 UTOS 또는 기타 Pearson 방침의 적용을 받지 않습니다. 제3자 사이트에 대한 링크가 더 이상 작동하지 않는 경우 <a target="_blank" href="https://pearson.tfaforms.net/3048">Pearson 지원 센터</a>로 문의하십시오. 사용자를 부적절한 콘텐츠 또는 금지된 사용자 콘텐츠로 연결하는 모든 링크는 <a href="mailto:pearsondmca.agent@pearson.com">pearsondmca.agent@pearson.com</a>으로 신고해야 합니다.'
      },
      '12': {
        question: '12. DMCA 통지 제출 방법',
        paragraph1:
          '서비스를 통해 사용할 수 있는 콘텐츠에 대한 저작권 문제가 있거나 DMCA 통지를 제출하고자 하는 경우, 아래의 자세한 지침을 참고해 주십시오.',
        paragraph2:
          '타인이 서비스에 게시한 자료에 대한 저작권 우려가 있거나 서비스에 게시된 부적절한 콘텐츠를 신고하려는 경우 당사에 알려주십시오. 당사는 인터넷 서비스 제공자에 적용되는 디지털 밀레니엄 저작권법(Digital Millennium Copyright Act, “DMCA”)의 규정(17 U.S.C. 섹션 512)을 준수합니다. Pearson이 제공한 특정 DMCA 지정에 달리 명시되지 않는 한, 다음 주소로 지정 대리인에게 연락하여 서면으로 통지("통지")하여 주시기 바랍니다.',
        paragraph3: 'DMCA 지정 대리인',
        paragraph4: 'Pearson Education, Inc.',
        paragraph5: '221 River Street',
        paragraph6: 'Hoboken, Nj 07030',
        paragraph7:
          '이메일: <a href="mailto:pearsondmca.agent@pearson.com">pearsondmca.agent@pearson.com</a>',
        paragraph8:
          '귀하가 저작권자 또는 저작권자의 수권 대리인이고, 저작권이 있는 저작물이 서비스를 통해 저작권 침해를 구성하는 방식으로 복사, 개조, 복제, 또는 전시되었다고 선의로 믿는 경우, 귀하는 당사의 지정 대리인에게 침해 행위를 주장하는 서면 통지를 제출할 수 있습니다. 통지가 효력을 발휘하려면 다음 사항을 포함해야 합니다.q',
        bullet1:
          '침해되었다고 주장되는 독점적 권리의 소유자 또는 소유자를 대리하여 행위하는 자("불만제기 당사자")의 물리적 또는 전자적 서명, Pearson이 불만제기 당사자에게 연락할 수 있도록 합리적으로 충분한 정보(예: 주소, 전화번호 및 가능한 경우 이메일 주소)',
        bullet2:
          '서비스에서 침해가 의심되는 자료("침해하는 자료")의 식별 및 Pearson이 서비스에서 해당 자료를 찾을 수 있도록 합리적으로 충분한 정보, 침해되었다고 주장되는 저작권 저작물("침해된 자료")의 식별, 또는 서비스 상 다수의 저작물이 단일 통지에 포함되는 경우, 침해되었다고 주장되는 각 저작물 목록(어느 침해하는 자료가 어느 침해된 자료를 침해하는 것인지 구체적으로 명시)',
        bullet3:
          '불만제기 당사자가 주장하는 방식으로 침해하는 자료를 사용하는 것이 저작권자, 그 대리인 또는 법률에 의해 허가되지 않았다는 선의의 믿음을 가지고 있다는 진술',
        bullet4:
          '통지의 정보가 정확하며, 위증에 대한 처벌 규정에 따라 불만제기 당사자가 침해되었다고 주장되는 독점적 권리의 소유자이거나 소유자를 대신하여 행위할 권한이 있다는 진술'
      },
      '13': {
        question: '13. 기타 금지된 콘텐츠를 신고하는 방법',
        paragraph1:
          '귀하가 서비스에서 발견한 콘텐츠 중 권리 침해적이거나, 모욕적이거나, 달리 UTOS 또는 AUP에 따라 금지된 콘텐츠는 당사에 알려주십시오. 당사 역시 이를 원하지 않습니다.',
        paragraph2:
          '또한 Pearson은 금지된 사용자 콘텐츠를 <a href="mailto:pearsondmca.agent@pearson.com">pearsondmca.agent@pearson.com</a>으로 신고할 것을 권장합니다. Pearson이 문제에 신속하게 대응할 수 있도록 귀하의 이메일에는 원본 Pearson 페이지 URL, 링크된 페이지 URL, 해당 콘텐츠에 대한 설명 및 콘텐츠가 금지되거나 부적절하다고 판단되는 근거, Pearson의 조사에 추가로 협조할 의사가 있는 경우 Pearson이 연락할 수 있는 연락처가 포함되어야 합니다.'
      },
      '14': {
        question: '14. 서비스 가용성',
        paragraph1:
          '귀하는 서비스가 (1) 사용을 위해서는 인터넷 접속이 필요하고, (2) 유지보수 또는 긴급 상황의 경우 종종 오프라인 상태가 될 수 있으며, (3) 특징과 기능이 시간이 지남에 따라 변경될 수 있음을 이해합니다.',
        paragraph2:
          '서비스의 범위 및 가용성은 (1) 구매 또는 등록 시 제시된 추가 조건, (2) 귀하가 등록한 특정 강좌 또는 서비스 및/또는 (3) Pearson과 귀하의 기관 간의 라이선스 조건에 따라 달라질 수 있습니다. Pearson은 제3자 서비스로 인해 발생하거나 귀하의 기관에서 설정한 특정 계정 설정으로 인해 발생하는 액세스 제한에 대해 책임을 지지 않습니다.',
        paragraph3:
          '귀하는 서비스를 사용하기 위해 인터넷 접속을 확보할 책임이 있습니다. 귀하는 서비스 사용 여부에 관계없이 구매한 구독 기간(일반적으로 강좌에 따라 1~2학기) 동안만 서비스를 통해 제공되는 강좌에 액세스할 수 있으며, UTOS에 따라 액세스를 해지할 수 있는 Pearson의 권리에 따릅니다. 기관에게 제공되는 액세스 기간은 다를 수 있습니다.',
        paragraph4:
          'Pearson은 유효한 구독을 통해 승인된 사용자에게 서비스를 제공하기 위해 합리적인 노력을 기울이지만, 예정된 정기 유지보수, 긴급 유지보수는 물론, 인터넷 서비스 중단, 서비스의 무결성 또는 보안에 대한 예기치 않은 위협 등 Pearson의 통제 범위를 벗어나는 요인으로 인해 제한된 기간 동안 서비스를 사용할 수 없게 될 수 있습니다.',
        paragraph5:
          'Pearson은 귀하에 대한 통지 여부와 관계없이 언제든지 서비스의 사용 및 접근성을 제한하거나 서비스의 일부, 기능 또는 콘텐츠를 중단할 수 있습니다. Pearson은 합리적으로 가능할 때마다 승인된 사용자에게 서비스의 중대한 변경 사항에 대해 유효한 구독 통지를 제공하기 위해 합리적인 노력을 기울일 것입니다. 서비스 변경 사항 및 가용성에 대한 정보 및 업데이트는 <a target="_blank" href="https://pearson.tfaforms.net/3048">Pearson 지원 센터</a>에 정기적으로 게시됩니다.'
      },
      '15': {
        question: '15. 서비스는 보증 없이 제공됩니다.',
        paragraph1:
          '서비스의 가용성 및 성능은 때때로 완벽하지 않을 수 있으며, 그럼에도 귀하는 서비스를 "있는 그대로" 본인의 위험부담으로 사용할 것에 동의합니다.',
        paragraph2:
          '귀하는 다음 사항을 명시적으로 인정하고 이에 동의합니다. (1) 귀하의 서비스 사용에 따른 위험은 귀하의 책임입니다. (2) 서비스는 "있는 그대로", "사용 가능한 대로" 제공됩니다. (3) 귀하는 서비스의 보증으로 간주되거나 Pearson의 책임에 대한 근거가 되는 Pearson의 대리인 또는 리셀러의 진술, 정보 또는 조언에 의존하지 않았습니다. (4) Pearson과 그 라이선스 제공자 및 계약자는 관련 법률이 허용하는 최대 한도 내에서, 이행 과정, 거래 과정, 상관습으로 인해 생성된 명시적 또는 묵시적 보증 및 조건(상품성, 특정 목적에의 적합성 및 비침해에 대한 묵시적 보증을 포함하나 이에 국한되지 않음)을 포함하여 여하한 종류의 보증이나 조건을 명시적으로 부인합니다.',
        paragraph3:
          'Pearson과 그 라이선스 제공자는 (1) 서비스 또는 귀하의 서비스 사용이 중단되지 않거나 오류가 없을 것, (2) 서비스 사용으로 얻을 수 있는 결과가 정확하거나 신뢰할 수 있을 것, 또는 (3) 서비스가 귀하의 요구 사항을 충족할 것을 진술 또는 보증하지 않습니다.',
        paragraph4:
          '귀하가 서비스에 업로드, 다운로드 또는 기타 방법으로 얻은 모든 자료는 본인의 재량과 위험에 따라 수행됩니다. 귀하가 서비스를 사용하여 업로드하거나 입력한 데이터의 모든 손실 또는 손상과 서비스 사용으로 인해 발생할 수 있는 하드웨어 및 소프트웨어의 모든 서비스, 수리, 수정 및 손해에 대한 책임은 전적으로 귀하에게 있으며, Pearson 또는 그 라이선스 제공자는 책임을 지지 않습니다.',
        paragraph5:
          '일부 관할권에서는 묵시적 보증 또는 소비자 보증의 배제를 허용하지 않으므로 상기 배제가 귀하에게 적용되지 않을 수 있습니다. 전술한 내용에도 불구하고, Pearson 측의 고의 또는 과실이 발생한 경우에는 본 섹션에 규정된 상기 보증 제외 조항이 적용되지 않습니다.'
      },
      '16': {
        question: '16. 귀하에 대한 Pearson의 책임은 제한적입니다.',
        paragraph1:
          '서비스에 문제가 발생할 경우, Pearson의 귀하에 대한 책임은 제한되며, 귀하의 청구 능력도 제한됩니다.',
        paragraph2:
          'UTOS의 어떠한 내용도 관련 법률에 따라 합법적으로 배제되거나 제한될 수 없는 조건, 보증, 권리 또는 책임을 배제하거나 제한하는 것을 의도하지 않습니다. 따라서 귀하의 관할권에서 합법적인 제한만이 귀하에게 적용되며, 그러한 경우 당사의 책임은 허용되는 최대 한도로 제한됩니다.',
        paragraph3:
          '어떠한 경우에도 Pearson 또는 그 직원, 임원, 대리인, 계약자 또는 라이선스 제공자는 여하한 종류의 보상적, 부수적, 간접적, 특별, 징벌적, 또는 결과적 손해(서비스, 제3자 웹사이트 또는 서비스를 통해 액세스한 애플리케이션의 사용 또는 사용 불능에 따른 청구 또는 손해, 재산상 피해, 제3자 청구, 일실이익, 영업권 손실, 데이터 또는 기타 무형의 손실, 서비스를 통해 제공되는 콘텐츠 또는 정보에 의존하여 발생하는 손실 및/또는 기타 서비스 사용으로 인해 발생하는 모든 종류의 손실)에 대해 책임을 지지 않습니다. 단, Pearson 측의 고의 또는 과실에는 적용되지 않습니다. 서비스와 관련하여 Pearson의 최대 총 책임은 손실이 발생한 특정 서비스에 대해 귀하가 지불한 총 수수료를 초과하지 않습니다. 단, Pearson 측의 고의 또는 중과실에는 적용되지 않습니다. 본 섹션에 명시된 제한은 Pearson이 손실 또는 손해의 가능성을 사전에 통보받은 경우 및/또는 UTOS의 제한적인 구제수단이 본질적인 목적을 달성하지 못할 경우에도 계약, 불법 행위 또는 기타 사유를 근거로 그러한 책임이 주장되는지 여부에 상관없이 적용됩니다.',
        paragraph4: ''
      },
      '17': {
        question: '17. 귀하가 Pearson에 야기한 모든 손해에 대한 책임은 귀하에게 있습니다.',
        paragraph1:
          '귀하는 규칙을 위반하거나 불법적인 목적으로 서비스를 사용하지 않을 것에 동의합니다. 그러나 그렇게 할 경우 Pearson에게 발생한 손해에 대해 보상하는 데 동의합니다.',
        paragraph2:
          '귀하는 서비스 사용 조건으로 Pearson에 다음 사항을 보증하고 진술합니다. (1) 귀하는 승인된 사용자입니다. (2) 귀하는 서비스를 사용할 때 해당 지역, 주, 국가 또는 국제 법률이나 규정 및/또는 기관의 학칙이나 정책을 항상 준수해야 합니다. (3) 귀하는 UTOS 또는  <a target="_blank" href="https://loginstatic.pearson.com/html/AcceptableUsePolicy.html">AUP</a>에 의해 불법적이거나 금지된 목적으로 서비스를 사용하지 않아야 합니다. 관련 법률이 허용하는 최대 한도 내에서 귀하는 Pearson과 그 직원, 임원, 대리인, 계약자 및 라이선스 제공자를 UTOS의 위반 또는 서비스의 무단 사용으로 인해 또는 어떤 식으로든 이와 관련하여 발생하는 모든 청구, 손해, 비용 또는 책임으로부터 방어, 면책하고 해를 입히지 않을 것에 동의합니다.'
      },
      '18': {
        question: '18. 분쟁이 발생하면 적용되는 법률과 청구가 제기될 수 있는 법원',
        paragraph1:
          '서비스에 대한 모든 소송은 뉴욕, 온타리오, 호주 또는 영국 법원에서 해결됩니다(귀하의 거주지에 따라 다름).',
        paragraph2:
          '귀하는 UTOS가 국제 물품 매매 계약에 관한 UN 협약의 적용을 받지 않으며, UTOS 또는 귀하의 서비스 사용과 관련된 모든 소송, 분쟁 또는 논쟁(각각 "청구")은 본 조항의 적용을 받음에 동의합니다.',
        paragraph3:
          '귀하가 미국에 거주하는 경우, 귀하는 (1) 모든 청구와 관련해서는 뉴욕 주 뉴욕 카운티에 위치한 법원의 대인적∙전속적 관할권 및 재판지에 따르며 (2) 모든 청구가 국제사법 원칙의 적용을 배제하고 뉴욕 주 법률에 따라 규율되고 해석된다는 데 동의합니다.',
        paragraph4:
          '귀하가 캐나다에 거주하는 경우, 귀하는 (1) 온타리오 주에 위치한 법원의 대인적∙전속적 관할권 및 재판지에 따르며 (2) 모든 청구가 국제사법 원칙의 적용을 배제하고 온타리오 주 법률 및 온타리오주에 적용되는 캐나다 법률에 따라 규율되고 해석된다는 데 동의합니다.',
        paragraph5:
          '귀하가 유럽연합("EU")에 거주하는 경우, 귀하는 귀하가 거주하는 국가 또는 잉글랜드 및 웨일스에서 당사를 상대로 청구를 제출할 수 있지만, 모든 청구가 국제사법 원칙의 적용을 받는 잉글랜드 및 웨일스 법률에 따라 규율되고 해석된다는 데 동의합니다.',
        paragraph6:
          '귀하가 호주에 거주하는 경우, 귀하는 (1) 빅토리아 주에 위치한 법원의 대인적∙전속적 관할권 및 재판지에 따르며 (2) 모든 청구가 국제사법 원칙의 적용을 배제하고 빅토리아 주 법률에 따라 규율되고 해석된다는 데 동의합니다.',
        paragraph7:
          '귀하가 미국, EU, 호주 및 캐나다 이외의 지역에 거주하는 경우, 귀하는 (1) 잉글랜드 및 웨일스에 위치한 법원의 대인적∙전속적 관할권 및 재판지에 따르며, (2) 모든 청구가 국제사법 원칙의 적용을 배제하고 잉글랜드 및 웨일스 법률에 따라 규율되고 해석된다는 데 동의합니다.'
      },
      '19': {
        question: '19. 귀하는 수출법 준수에 동의합니다.',
        paragraph1:
          '귀하가 (1) 미국 정부가 "테러리스트 지원국"으로 지정한 국가에 소재하거나 (2) 미국 정부의 금지 또는 제한 당사자 목록에 등재된 경우 서비스를 사용할 수 없습니다. 또한 귀하는 미국 수출 허가가 필요한 국가에 서비스를 수출하지 않을 것을 약속합니다.',
        paragraph2:
          '서비스, 애플리케이션 및 관련 기술의 사용은 미국 또는 국제 통제 또는 수출법 및 규정("수출법")의 적용을 받습니다. 이에 국한되지 않고 귀하는 모든 수출법을 엄격히 준수할 것에 동의하며, 필요에 따라 애플리케이션 및 관련 기술의 수출, 재수출 또는 수입에 대한 인가를 득할 책임이 있음을 인정합니다. 귀하는 귀하가 (1) 미국 정부의 금수조치가 적용되는 국가 또는 미국 정부에 의해 "테러리스트 지원국"으로 지정된 국가에 거주하지 않으며, (2) 미국 정부의 금지 또는 제한 당사자 목록에 등재되어 있지 않음을 진술 및 보장합니다. 귀하는 미국 정부 또는 해당 기관이 수출 허가를 요구하거나 달리 수출을 제한하는 국가나 해당 국가의 대리인, 대표자 또는 외국인에게 서비스를 전자적 수단 등을 통해 직접 또는 간접적으로 이전하지 않을 것에 동의합니다. 귀하는 본 섹션에 따른 귀하의 의무 위반으로부터 또는 그와 관련하여 발생하는 모든 청구, 손실, 책임, 손해, 벌금, 위약금, 비용 및 경비(변호사 비용을 포함하되 이에 국한되지 않음)로부터 Pearson을 면책하고 손해를 입지 않도록 합니다.'
      },
      '20': {
        question: '20. 구독 및 서비스 액세스 해지',
        paragraph1:
          '귀하 또는 Pearson은 아래 명시된 사유로 언제든지 귀하의 구독을 취소할 수 있습니다.',
        paragraph2:
          '평가판 액세스.경우에 따라, 귀하는 서비스를 평가판 검토 기간(일반적으로 최대 15일)("검토 기간")동안 사용할 수 있습니다. 검토 기간 동안 귀하는 무료로 서비스에 액세스할 수 있습니다. 그러나 검토 기간이 제한된 경우, 검토 기간 종료 전에 결제가 이루어지지 않으면 평가판 검토를 위해 제공된 서비스에 대한 액세스가 종료됩니다. 서비스가 종료된다고 해서 사용자 계정이 자동으로 해지 되지는 않습니다. 또한, 귀하는 검토 기간 중 언제든지 Pearson이 단독 재량으로 귀하가 검토 기간을 유료 서비스를 대신하여 활용한다고 판단할 경우, 검토 기간이 부여된 해당 서비스에 대한 귀하의 액세스가 즉시 해지되거나 일시 중단될 수 있음을 명시적으로 인정하고 이에 동의합니다. 이러한 서비스에 대한 귀하의 액세스가 일시 중단 또는 해지되는 경우, 귀하는 (1) 서비스, 그 기능, 활동, 자료 또는 귀하의 사용으로 인해 생성된 모든 결과물이 귀하 또는 제3자에게 제공되지 않을 수 있으며, (2) 귀하 또는 제3자 누구도 귀하가 중단 또는 해지된 강좌, 그 기능, 활동 또는 자료의 사용으로 생성된 결과물이 강좌 또는 서비스 내에서 이용 가능한지 여부를 불문하고 이에 액세스하거나 이를 사용할 권한이 없음을 인정하고 이에 동의합니다. 귀하가 강좌 구독을 구매하지 않아 강좌에 대한 액세스가 해지된 후 Pearson이 추후 대금을 수령하여 강좌에 대한 귀하의 액세스 권한을 복원할 경우, 복원된 액세스는 UTOS의 조건을 따릅니다.',
        paragraph3:
          '귀하에 의한 해지.귀하의 기관 또는 서비스에 대한 액세스가 제공되는 제3자 서비스에 의해 부과될 수 있는 계정 제한에 따라 귀하는 귀하의 결정을 Pearson에 통지함으로써 언제든지 귀하의 사용자 계정을 해지할 수 있습니다. 당사는 서비스에 대한 귀하의 만족도를 중요하게 생각합니다. 서비스에 대한 우려 사항 또는 불만 사항이 있거나 서비스에 대한 액세스를 해지하려면 <a target="_blank" href="https://pearson.tfaforms.net/3048">Pearson 지원 센터</a>로 문의하십시오.',
        paragraph4:
          'Pearson에 의한 해지.Pearson은 단독 재량으로, 사전 통지 여부에 관계없이, 그리고/또는 귀하 기관의 요청에 따라, UTOS 또는 AUP를 위반한다고 Pearson이 합리적으로 판단하는 행위 또는 사용(귀하에 의한 것인지 또는 귀하의 사용자 계정으로 서비스에 액세스하는 제3자에 의한 것인지 불문)에 대해 서비스의 전부 또는 일부에 대한 귀하의 액세스 또는 귀하의 사용 권한을 일시 중단하거나 해지할 수 있습니다.',
        paragraph5:
          '해지의 효과.해지가 귀하, 귀하의 기관 또는 Pearson에 의해 개시 되었는지에 관계없이 UTOS 및 AUP의 조건 및 UTOS의 섹션 10, 20, 21은 그러한 해지 이후에도 존속합니다. 사용자 계정 정보, 데이터, 설정 또는 사양이나 귀하의 사용자 계정에 특정된 서비스 또는 구독의 커스터마이징은 서비스 또는 구독이 해지되면 해지가 귀하, Pearson 또는 귀하의 기관에 의한 것인지 불문하고 영구적으로 손실될 수 있습니다. 귀하의 서비스 사용과 관련된 사용자 콘텐츠 및 기타 사용자 정보는 해지 후에도 귀하의 기관에 의해 또는 공개 포럼에 게시된 경우에 한하여 서비스의 다른 사용자에 의해 여전히 액세스될 수 있습니다.'
      },
      '21': {
        question: '21. UTOS에 따른 귀하의 배타적 구제수단',
        paragraph1:
          '문제가 생겼을 때 UTOS에 따른 귀하의 유일한 해결책은 (1) 서비스에 대한 액세스 복구 또는 (2) 수수료의 비례 환불입니다.',
        paragraph2:
          '서비스 사용과 관련하여 귀하에 대한 Pearson의 전적인 책임과 귀하의 배타적인 구제수단은 Pearson의 단독 재량에 따라 (1) 귀하가 가입한 서비스에 대한 액세스를 복구하거나 (2) 귀하가 특정 서비스 또는 구독에 대해 Pearson에 직접 지불한 수수료를 비례 환불하는 것입니다.',
        paragraph3:
          '환불은 가능한 경우 등록 후 최초 15일 이내에 귀하가 서면으로 요청한 경우에만 이루어집니다. 승인된 사용자가 Pearson 웹사이트에서 직접 구매한 경우에만 환불이 가능합니다. 분실 또는 도난당한 액세스 코드 또는 제3자(예: 캠퍼스 서점)를 통해 구입한 경우에는 환불이 불가능합니다. 서비스에 불만이 있거나 환불을 요청하려면  <a target="_blank" href="https://pearson.tfaforms.net/3048">Pearson 지원 센터</a>로 문의하십시오.',
        paragraph4:
          '귀하가 호주에 거주하는 경우에는 서비스에 호주 소비자 보호법(소비자 보증)에 따라 배제될 수 없는 보증이 제공됩니다. 서비스가 소비자 보증을 충족하지 못할 경우 귀하가 받을 수 있는 구제수단은 소비자 보증 미준수가 중대한지 경미한지에 따라 달라집니다.'
      },
      '22': {
        question: '22. 기타 추가 조건',
        paragraph1:
          'UTOS는 귀하에게 일신 전속적이며, 귀하는 귀하의 사용자 계정 또는 UTOS 또는 AUP(총칭하여 "약관")에 따른 귀하의 권리나 의무를 누구에게도 양도, 이전 또는 위임할 수 없습니다. Pearson은 약관에 따른 Pearson의 권리 및 의무의 전부 또는 일부를 약관 및 귀하의 기관과의 계약에 따른 권리 또는 의무에 따라 양도하거나 위임할 수 있습니다. 약관의 조항이 관할 법원에 의해 어떠한 이유로든 무효하거나 집행 불가능한 것으로 판단되는 경우, 약관의 나머지 조항은 해당 조건에 따라 유효하고 집행 가능한 상태로 유지됩니다. 약관은 서비스와 관련하여 Pearson과 귀하 간의 완전한 합의를 구성하며, 서명된 서면 합의 없이 약관을 수정할 수 없습니다. 약관의 섹션 제목 및 요약은 귀하의 편의를 위한 것이며 법적 의미나 효력을 갖지 않습니다. 행위 등에 의한 것인지를 불문하고, Pearson이 약관의 조항 또는 조건을 1회 이상 포기하거나 집행하지 않는 경우, 그러한 포기 또는 집행 불이행은 Pearson이 다른 시점에 약관의 조항 또는 조건을 집행하는 것을 방해하지 않습니다. 당사자들은 약관 및 모든 관련 문서를 영어로 작성하는 것을 명시적으로 희망합니다. '
      }
    },
    preSection2: {
      header: '{{productName}} 보충 약관'
    },
    content2: {
      '1': {
        question: '1. 소개',
        bullet1:
          '본 {{productName}} 보충 약관("VPEC 보충 약관")은 Pearson Education Ltd("Pearson" 또는 "당사")와 당사 또는 전 세계 당사의 계열사에 {{productName}}("VPEC")를 등록한 응시자("응시자" 또는 "귀하") 간의 계약에 편입되어 그 일부를 구성합니다.',
        bullet2:
          '응시자는 시험의 구입을 완료하기 전에 VPEC 보충 약관에 동의해야 합니다. 귀하는 VPEC 보충 약관에 명시되지 않은, Pearson에 의해 또는 Pearson을 대신하여 부여되거나 제공되는 서술, 약속, 진술, 확약 또는 보증에 의존하지 않았음을 인정합니다.',
        bullet3:
          'VPEC 보충 약관, 일반 서비스 약관 및 최종 사용자 라이선스 계약과 시험 응시자를 위한 VPEC 공식 가이드(“가이드”)는 VPEC와 관련하여 당사와 응시자 간의 완전한 합의를 구성합니다.'
      },
      '2': {
        question: '2. VPEC 공식 가이드',
        bullet1:
          '여기에서 제공되는 가이드와 <a target="_blank" href="{{ url }}">{{ url }}</a>을 통해 제공되는 모든 지원 리소스(예: FAQ 및 비디오)에는 시험 준비 및 응시에 대한 세부 정보를 포함하여 VPEC에 적용되는 규칙 및 규정에 대한 세부 정보가 포함되어 있습니다. 귀하가 VPEC 시험에 등록하거나 응시할 때, 귀하는 가이드를 읽고 이해했으며 이에 동의함을 나타냅니다.',
        bullet2:
          '귀하가 가이드와 지원 자료에 명시된 규칙을 준수하지 않을 경우, 귀하는 당사가 귀하의 시험 결과를 인증하지 않는 등의 조치를 취할 수 있다는 데 동의합니다.'
      },
      '3': {
        question: '3. 개인정보 보호',
        bullet1:
          'Pearson은 등록, 예약 및 시험 응시 절차 중 모든 단계에서 귀하로부터 귀하에 대한 개인정보를 수집합니다. 귀하의 모든 개인정보는 안전한 방식으로 수집, 전송 및 저장되며, <a target="_blank" href="{{ url }}/privacy-policy">여기</a>에서 볼 수 있는 개인정보 처리방침에 명시된 목적으로만 이용됩니다.'
      },
      '4': {
        question: '4. 기밀 유지',
        bullet1:
          '응시자는 시험 문제 및 답안 사본을 가져가거나 시험의 항목 또는 답안을 타인과 공유할 수 없습니다. 학습 가이드 또는 연습 세션에서 시험 항목 및 답안의 비상업적 사용도 금지됩니다.'
      },
      '5': {
        question: '5. 취소 및 환불 정책',
        bullet1:
          '시험 구매 후 90일이 경과하지 않았고 시험이 시작되지 않은 경우, 귀하는 시험에 대한 전액 환불을 요청할 수 있습니다. 당사는 시험 구매에 사용된 지불 방법을 사용하여 시험 가격(GST/VAT/소비세/정부 부과금 포함)을 환불 또는 공제하고 신청서에서 시험을 삭제합니다.',
        bullet2:
          '단, Pearson 측의 고의 또는 중과실의 경우를 제외하고는 <u>시험이 시작된 후(장비 고장의 사유 포함)에는 시험을 취소하고 환불을 요청할 수 없으며, 시험 구매 시기에 관계없이 적용됩니다. 시험은 설정 점검이 완료된 후 시작된 것으로 간주됩니다.</u>',
        bullet3:
          '시스템 오류로 인해 시험을 완료할 수 없는 경우 Pearson은 단독 재량에 따라 대체 시험 또는 환불을 제공할 수 있습니다.',
        bullet4:
          '귀하는 문제가 생긴 경우 당사 고객 서비스 팀에 조사를 위해 <a target="_blank" href="https://pearson.tfaforms.net/3048">이 양식</a>을 사용하여 신고해야 합니다.',
        bullet5:
          '취소 또는 환불 정책의 어떠한 내용도 귀하가 소비자 보호법 또는 규정에 따라 보유할 수 있는 권리 또는 Pearson이 기술적 결함의 유일한 원인인 경우에 우선하지 않습니다.'
      },
      '6': {
        question: '6. 책임의 제한',
        bullet1:
          'Pearson은 당사의 과실, 직원 또는 대리인의 과실 또는 사기성 허위 진술로 인한 사망 또는 신체적 상해에 대한 책임을 제한하거나 배제하지 않습니다.',
        bullet2:
          '상기 제6(a)항에 따라, 그리고 관련 법률이 허용하는 최대 한도 내에서, Pearson은 어떠한 경우에도 계약, 불법 행위(과실 포함) 또는 기타 이유에 의한 것인지 불문하고 (i) VPEC 또는 귀하의 시험과 관련된 Pearson의 작위 또는 부작위의 결과로 귀하에게 발생한 사업 손실, 일실이익, 기회 손실, 간접적 손실, 결과적 손실 또는 (ii) 시험 센터, 시험 센터 직원 또는 대리인의 작위 또는 부작위에 대해 귀하에게 책임을 지지 않습니다.',
        bullet3:
          '귀하에게 발생한 기타 모든 비용 또는 손실과 관련하여 Pearson이 귀하에 대하여 부담하는 총 책임은 법률에서 달리 요구하지 않는 한 귀하가 관련 시험과 관련하여 Pearson에 지불한 금액을 초과할 수 없습니다.',
        bullet4:
          '당사가 합리적인 통제 범위를 벗어난 상황으로 인해 VPEC 제공과 관련한 당사의 의무를 이행하지 못하거나 이행을 지연하는 경우, 당사는 해당 의무 이행에 필요한 시간을 합리적으로 연장할 권리가 있습니다.'
      },
      '7': {
        question: '7. 일반 조항',
        bullet1:
          '당사는 VPEC 보충 약관을 수시로 개정할 수 있습니다. 중요한 변경 사항은 귀하가 제공한 이메일 주소를 통해 이메일로 알려드립니다.',
        bullet2:
          '상충하는 경우 VPEC 보충 약관이 우선하며, 그 다음 일반 서비스 약관 및 최종 사용자 라이선스 계약, 시험 응시자를 위한 VPEC 공식 가이드가 적용됩니다.',
        bullet3:
          'VPEC 보충 약관이 관할 당국에 의해 무효, 불법 또는 집행 불가능하다고 판단되는 경우, 해당 약관, 조건 또는 조항은 그 범위 내에서 나머지 약관, 조건 및 조항과 분리되며, 나머지 약관 조건 및 조항은 법이 허용하는 최대 한도까지 계속 유효합니다.',
        bullet4:
          '당사가 VPEC 보충 약관에 따른 귀하의 의무의 엄격한 이행을 주장하지 않거나 당사의 마땅한 권리 또는 구제수단을 행사하지 않는 경우, 이는 해당 권리 또는 구제수단의 포기로 간주되지 않으며, 귀하가 그러한 의무를 준수하는 것을 면제하지 않습니다. 당사의 불이행에 대한 권리 포기는 추후 불이행에 대한 권리 포기를 구성하지 않습니다.'
      },
      '8': {
        question: '8. 연락처',
        bullet1:
          '문제가 있는 경우 <a target="_blank" href="https://pearson.tfaforms.net/3048">이 양식/a>을 사용하여 고객 서비스 팀에 문의하시기 바랍니다.'
      }
    }
  },
  cookiePolicy: {
    downloadButton: '쿠키 정책 다운로드',
    header: '쿠키 정책',
    subheader:
      '쿠키 정책이 업데이트되었습니다. 변경 사항에는 개인정보 판매 금지 및 캘리포니아 소비자 개인정보 보호법에 대한 새로운 섹션 및 쿠키 목록에 대한 업데이트가 포함됩니다.',
    preSection: {
      header: '일반 서비스 약관 및 최종 사용자 라이선스 계약',
      paragraph1:
        '본 쿠키 정책은 Pearson Education, Inc.(221 River Street, Hoboken, New Jersey 07030)가 자회사\n' +
        '및 계열사(총칭하여 “Pearson”)와 협력하여 제공하는 pearson.com/en-us.html 사이트에서\n' +
        "사용되는 쿠키에 대한 정보를 제공합니다. 본 쿠키 정책을 이 사이트의 <a href='{{privacyPolicyLink}}'><strong>개인정보 처리방침</strong></a>함께 읽어보시기 바랍니다.",
      paragraph2:
        '다른 많은 웹사이트와 마찬가지로 이 사이트는 쿠키를 사용하여 사용자 기본 설정을 저장하고, 웹사이트를 보다 사용자 친화적으로 만들고, 사이트 사용 및 성능에 대한 정보를 수집하고, 타겟 메시징 및 마케팅을 촉진합니다.'
    },
    content: {
      paragraph1: {
        header: '개인정보 판매 금지 및 캘리포니아 소비자 개인정보 보호법',
        description:
          'CA, CO, CT, NV, UT 및 VA를 포함한 여러 주에서는 거주자에게 개인정보의 판매, 개인정보의 공유 또는 둘 다를 거부할 수 있는 다양한 권리를 부여합니다.'
      },
      paragraph2: {
        description:
          'Pearson은 서비스를 통해 수집한 개인정보를 판매하거나 공유하지 않으며, 지난 12개월 이내에 판매하거나 공유한 적이 없습니다.'
      },
      paragraph3: {
        header: '쿠키 비활성화 또는 차단',
        description:
          '쿠키는 사용자가 사용하는 각 컴퓨터 및 브라우저의 인터넷 브라우저 설정을 통해 차단되거나 비활성화될 수 있습니다. 또한 사용자는 <a href="http://optout.networkadvertising.org">http://optout.networkadvertising.org/</a> 또는 <a href="http://optout.aboutads.info">http://optout.aboutads.info/</a>에서 각각 네트워크 광고 이니셔티브(Network Advertising Initiative) 또는 디지털 광고 얼라이언스(Digital Advertising Alliance)에 참여하는 광고 네트워크 및 기업에 대한 옵트아웃 도구를 사용할 수 있습니다.'
      },
      paragraph4: {
        description:
          '브라우저 설정 또는 이러한 광고 업계 옵트아웃 도구를 통해 쿠키를 효과적으로 관리하려면 사용하는 모든 브라우저와 모든 기기에서 쿠키를 옵트아웃하고 기본 설정을 지정하십시오. 또한, 캐시 또는 쿠키를 삭제한 후 기본 설정을 확인하고 재설정하십시오.'
      },
      paragraph5: {
        description:
          '쿠키를 비활성화하거나 차단하면 이 사이트 및 다른 사이트의 기능이 저하될 수 있습니다.'
      },
      paragraph6: {
        description:
          '쿠키를 비활성화하거나 차단하기 위해 브라우저 설정을 보고 변경하는 방법은 다음과 같습니다.'
      },
      paragraph7: {
        description:
          "Google Chrome <br/>스패너 아이콘(브라우저의 상단 메뉴)을 클릭하고 '설정'을 선택합니다. <br /> 왼쪽의 '언더 보닛 ' 탭을 클릭한 다음 '콘텐츠 설정' 버튼을 선택합니다. <br /> 쿠키 섹션에서 귀하의 요건에 가장 적합한 옵션을 선택합니다."
      },
      paragraph8: {
        description:
          "Microsoft Internet Explorer <br/> '도구'(브라우저의 상단 메뉴)를 클릭하고 '인터넷 옵션'을 선택합니다. <br/> '개인정보' 탭을 클릭합니다. <br/> 개인정보 슬라이더를 귀하가 필요한 개인정보 수준으로 이동시킵니다. <br/> 보통 수준 이상으로 설정하면 <br/> 쿠키가 비활성화됩니다."
      },
      paragraph9: {
        description:
          "Mozilla Firefox <br/> '도구'(브라우저의 상단 메뉴)를 클릭하고 '옵션'을 선택합니다. <br/> 개인정보 아이콘을 선택합니다. <br/> 기록 섹션의 드롭다운 메뉴에서 '기록 맞춤 설정 사용'을 선택합니다. <br/> 적절한 확인란을 클릭하여 쿠키를 활성화 또는 비활성화할 수 있습니다."
      },
      paragraph10: {
        description:
          "Safari <br/> 톱니바퀴 아이콘(브라우저의 상단 메뉴)을 클릭하고 '기본 설정'을 선택합니다. <br/> 개인정보 탭을 클릭하고 귀하의 요건에 가장 적합한 옵션을 선택합니다."
      },
      paragraph11: {
        description:
          "Opera <br/> 브라우저 창 상단에 있는 '도구'를 클릭하고 '기본 설정'을 선택합니다. <br/> '고급' 탭을 선택하고 왼쪽 목록에서 쿠키를 선택합니다. <br/> 귀하의 요건에 가장 적합한 옵션을 선택합니다."
      },
      paragraph12: {
        description:
          "OSX의 Safari <br/> 브라우저 창 상단의 'Safari'를 클릭하고 '기본 설정'을 선택합니다. <br/> '개인정보' 탭을 클릭합니다. <br/> 여기에서 쿠키 허용 수준을 조정합니다."
      },
      paragraph13: {
        description:
          "Firefox <br/> 브라우저 창 상단에서 'Firefox'를 클릭하고 '기본 설정'을 선택합니다. <br/> 개인정보 보호 아이콘을 선택합니다. <br/> 기록 섹션의 드롭다운 메뉴에서 ' 기록 맞춤 설정 사용'을 선택합니다. <br/> 적절한 확인란을 클릭하여 쿠키를 활성화 또는 비활성화할 수 있습니다."
      },
      paragraph14: {
        header: '쿠키 목록',
        description:
          '쿠키는 일반적으로 (1) 필수 쿠키, (2) 성능 쿠키, (3) 기능 쿠키, (4) 행동 타겟팅 광고/마케팅 쿠키 등 네 가지 범주로 나뉩니다.'
      },
      paragraph15: {
        description:
          '이 사이트pearson.com/us와 관련하여 사용되는 쿠키에는 이러한 각 범주의 쿠키가 포함되며 아래에 나열된 쿠키를 포함할 수 있습니다(이에 국한되지는 않음).'
      },
      paragraph16: {
        description:
          '당사의 온라인 제품 및 서비스를 포함한 다른 Pearson 사이트의 쿠키 사용은 다를 수 있으며, 예를 들어 행동 타겟팅 마케팅 쿠키가 제외될 수 있습니다.'
      },
      paragraph17: {
        header: '필수 쿠키',
        bullet1: {
          description:
            '세션 기반: 분석을 위해 사이트 이용에 관한 정보를 수집하고 운영을 개선하거나 문제점을 파악하여 대응할 수 있도록 합니다.',
          subbullet1:
            '<strong>AWSALB, AWSELB</strong> - AWS가 "고정 세션"을 만들기 위해 설정한 쿠키',
          subbullet2: '<strong>YSESSIONID</strong> - Hybris 세션 ID',
          subbullet3:
            '<strong>acceleratorSecureGUID</strong> - Hybris 보안 GUID 쿠키가 사용자에게 유효한 세션이 있는지를 평가',
          subbullet4:
            '<strong>cookie-notification</strong> - 사용자가 쿠키 알림 팝업을 닫을 때 설정'
        },
        bullet2: {
          description:
            '지역 타겟팅: 사용자의 국가 또는 주를 식별하여 해당 지역 또는 관할권과 관련된 정보를 표시할 수 있도록 합니다.',
          subbullet1:
            '<strong>geotargetsite</strong> - Akamai를 통해 IP를 기반으로 사용자 위치 추적',
          subbullet2:
            '<strong>geotargetchosenlocale</strong> - 사용자가 특정 국가의 매장을 탐색하도록 선택할 때 추적',
          subbullet3: '<strong>system-msg</strong> - 헤더의 글로벌 메시징 구성 요소에 사용'
        },
        bullet3: {
          description:
            'Google 애널리틱스: 사용자가 사이트를 사용하고 사이트와 상호작용하는 방식에 대한 데이터를 수집합니다. 사이트의 성능을 분석하고 고객 경험을 최적화하는 데 사용됩니다.',
          subbullet1: '<strong>_iutma</strong> - 고유 방문자를 추적하는 Google 애널리틱스 쿠키',
          subbullet2:
            '<strong>_utmb</strong> - 방문자 행동을 추적하고 사이트 성능을 측정하는 Google 애널리틱스 쿠키',
          subbullet3:
            '<strong>_utmc</strong> - 방문자 행동을 추적하고 사이트 성능을 측정하는 Google 애널리틱스 쿠키',
          subbullet4:
            '<strong>_utmt</strong> - 서비스에 대한 요청 속도를 조절하는 Google 애널리틱스 쿠키',
          subbullet5: '<strong>_utmv</strong> - 사용자 분류에 사용되는 Google 애널리틱스 쿠키',
          subbullet6: '<strong>_utmz</strong> - Google 애널리틱스 쿠키',
          subbullet7: '<strong>_ga</strong> - 사용자를 구별하는 Google 애널리틱스 쿠키',
          subbullet8: '<strong>_gat_UA-93818630</strong> - Google 애널리틱스 계정 번호의 식별자',
          subbullet9: '<strong>_gid</strong> - 사용자를 구별하는 Google 애널리틱스 쿠키',
          subbullet10:
            '<strong>_rollupGa</strong> - 고유한 클라이언트 식별자를 저장하는 Google 애널리틱스 쿠키'
        }
      },
      paragraph18: {
        header: '성능 쿠키',
        bullet1: {
          description: 'Optimize: 다변량 테스트 도구. 고객 경험을 최적화하는 데 사용됩니다.'
        },
        bullet2: {
          description:
            'hotjar: 사이트와 사용자 간 상호작용의 히트맵을 기록합니다. 사이트의 성능을 분석하고 고객 경험을 최적화하는 데 사용됩니다.'
        },
        bullet3: {
          description:
            'LiveIntent: 교차 장치 식별 도구. 웹사이트 분석 및 사용자 경험 최적화에 사용됩니다.'
        }
      },
      paragraph19: {
        header: '기능 쿠키',
        bullet1: {
          description: 'Maritz: 고객 만족도 설문 조사를 배포하는 데 사용됩니다.'
        }
      },
      paragraph20: {
        header: '행동 타겟팅 광고 쿠키',
        bullet1: {
          description:
            'Pardot: 고객 및 캠페인 추적에 사용되는 마케팅 플랫폼. 고객의 관심사와 대상 캠페인에 대한 반응을 파악하는 데 사용됩니다. Pearson의 사용을 위해 정보를 수집하는 경우에만 활성화됩니다.'
        },
        bullet2: {
          description:
            'Facebook: 소셜 미디어 마케팅. Facebook 플랫폼에 배포된 마케팅 캠페인을 추적하고 측정하는 데 사용됩니다. Facebook은 이러한 도구를 통해 고객의 행동을 추적합니다.'
        },
        bullet3: {
          description:
            'Twitter: 소셜 미디어 마케팅. Twitter 플랫폼에 배포된 마케팅 캠페인을 추적하고 측정하는 데 사용됩니다.'
        },
        bullet4: {
          description:
            'Linked In: 소셜 미디어 마케팅. Linked In 플랫폼에 배포된 마케팅 캠페인을 추적하고 측정하는 데 사용됩니다.'
        },
        bullet5: {
          description:
            'Google 광고: 검색 미디어 마케팅. Google 검색 및 관련 Google 서비스 내에서 마케팅 캠페인을 추적하고 측정하는 데 사용됩니다.'
        },
        bullet6: {
          description:
            'Salesforce: 판매 지원 도구. 고객의 지원 도구 사용을 추적하고 측정하는 데 사용됩니다. Pearson의 사용을 위해 정보를 수집하는 경우에만 활성화됩니다.'
        },
        bullet7: {
          description:
            'Pearson Education: 판매 지원 도구. 고객 전자 상거래 사용을 추적하고 측정하는 데 사용됩니다.'
        }
      },
      paragraph21: {
        header: '변경',
        description:
          '당사는 업데이트된 게시물을 통해 본 쿠키 정책을 수정할 수 있습니다. 당사는 게시물에 수정의 효력 발생일을 명시합니다. 보다 명확한 정보를 제공하거나 규제 요건의 변경 사항을 준수하기 위해 업데이트가 이루어지는 경우가 많습니다. 업데이트에 중대한 변경이 포함되는 경우, 당사는 이 사이트에서 눈에 띄는 공지나 기타 적절한 방법을 통해 변경 사항을 통지합니다. 귀하가 게시된 수정안 효력 발생일 이후에도 사이트를 계속 사용하는 경우, 이는 귀하가 수정을 수락함을 의미합니다. 변경 사항에 대한 질문, 우려 사항 또는 이의가 있는 경우 당사에 문의하십시오.'
      },
      paragraph22: {
        header: '문의하기',
        description:
          '본 쿠키 정책에 대한 문의 또는 Pearson이 수집하거나 처리하는 개인정보의 보호와 관련된 요청 또는 질문은 당사에 <a target="_blank" href="https://pearson.tfaforms.net/3048">문의</a>하십시오.'
      },
      paragraph23: {
        header: '마지막 업데이트: 2022년 12월 13일'
      }
    }
  },
  results: {
    specifyOrganization: '기관 지정',
    yourScoreHasBeenSentToEndCustomer: '점수가 다음 기관으로 전송되었습니다: ',
    header: '내 결과',
    noTestsTakenDescription: '시험을 치른 다음 여기에서 성적을 확인하세요!',
    myTopScoreHeader: 'MyTopScore™',
    gseScore: '종합 점수',
    viewDetails: '세부정보 보기',
    skillScoresTableHeaders: ['시험', '시험 ID', '날짜', 'GSE 점수', 'CEFR'],
    myTopScoreTableHeaders: [
      '시험',
      '시험 ID',
      '수험일',
      '말하기',
      '듣기',
      '읽기',
      '쓰기',
      '종합 점수',
      ''
    ],
    resultsTablesHeaders: [
      '시험',
      '날짜',
      '상태',
      '말하기',
      '듣기',
      '읽기',
      '쓰기',
      '종합 점수',
      'CEFR',
      ''
    ],
    resultsPracticeTableHeaders: [
      '시험',
      '날짜',
      '말하기',
      '듣기',
      '읽기',
      '쓰기',
      '종합 레벨',
      ''
    ],
    latestTest: '최근 시험',
    yourSpeakingWasUnscorable:
      '말하기 시험은 채점이 불가했습니다. 아래에서 자세한 내용을 확인하세요',
    somethingWentWrong:
      '문제가 발생했습니다. 자세한 정보를 알아보고 무료 재시험을 치르려면 시험 상세정보를 확인하세요.',
    unableToCertifyScore:
      '안타깝지만 점수를 인증할 수 없습니다.<br /> 아래에서 시험 상세정보를 확인하세요.',
    appealBeingReviewed:
      '학습자님이 제출하신 이의제기를 저희 팀에서 검토하고 있습니다. 나중에 다시 최종 점수를 확인해 주세요.',
    testBeingReviewed:
      '저희 팀에서 학습자님의 시험을 검토하고 있습니다. 나중에 다시 최종 점수를 확인해 주세요.',
    uploading:
      '학습자님의 답변이 백그라운드에서 업로드되는 중입니다. 모든 답변이 업로드되면 인증 절차가 시작됩니다.',
    thisTestHasStarted: '이 시험은 진행 중입니다. 시험을 마치면 여기에 점수가 표시됩니다.',
    testWasNotCompleted:
      '이 시험은 조기에 종료되었습니다. 안타깝지만 학습자님께 점수를 드릴 수 없습니다.',
    allYourTests: '모든 시험',
    allYourPracticeTests: '모든 모의고사',
    allResults: '모든 결과',
    yourTests: '시험',
    yourPracticeTests: '모의고사',
    resultDetails: '결과 세부정보',
    expiresIn: '{{daysToExpire}}일 후에 만료됨',
    expired: '만료됨',
    downloadingAssets: '에셋 다운로드 중',
    resultBadge: {
      certified: '인증됨',
      unscorable: '채점 불가',
      pendingCertification: '검토 보류 중',
      unabletoCertify: '인증 불가',
      speakingUnscorable: '말하기 채점 불가',
      appealed: '이의 제기 완료',
      started: '시작됨',
      incomplete: '미완료',
      uploading: '업로드 중',
      ruleViolation: '규정 위반',
      inProgress: '진행 중',
      completed: '완료됨',
      error: '처리할 수 없음',
      lateHangup: '지연 종료'
    },
    reasonsforDeniedCertification: '인증 거부 사유',
    reason: '사유 {{number}}',
    skillScores: '영역 점수',
    understandingYourSkills: '내 영역별 실력 살펴보기',
    overallScore: '종합 점수',
    overallScoreDescription:
      '시험 종합 점수는 발화된 영어를 이해하고 일상적인 화제에 대해 평범하게 대화하는 속도로 원어민처럼 명료하게 영어를 말할 수 있음을 나타냅니다. 점수는 4개 영역 진단 하위 점수에 가중치를 적용하여 복합적으로 산출됩니다.',
    gse: 'GSE',
    gseDescription:
      'Global Scale of English(GSE)는 10~90점까지 세밀하게 분류된 표준화된 척도로서 영어 숙련도를 측정하는 데 활용됩니다. 자세한 내용은 <a>English.com/gse</a>에서 확인하세요.',
    mtsDescription:
      '<italic>MyTopScore</italic>는 지난 6개월 동안 학습자가 치른 시험의 각 영역별 최고 점수를 활용하여 산출됩니다.',
    overallDescription:
      '시험 종합 점수는 발화 및 서면 영어를 이해하고 학술과 업무 관련 화제에 대해 적절한 속도로 명료한 영어를 사용하여 적절하게 말하거나 글로 써서 답변할 수 있음을 나타냅니다. 점수는 GSE의 10~90점 척도 범위로 측정됩니다.',
    sampleResponses: '샘플 답변',
    downloadCertificate: '성적증명서 다운로드',
    writingSampleTitle: '쓰기 샘플',
    writingSampleText: '수험자의 쓰기 시험 샘플 읽기',
    speakingSampleTitle: '말하기 샘플',
    speakingSampleText: '수험자의 말하기 시험 샘플 듣기',
    speakingSample: '말하기 샘플',
    writingSample: '쓰기 샘플',
    speakingSkill: '말하기 영역',
    writingSkill: '쓰기 영역',
    scoreSummary: '점수 요약',
    viewMyScore: '내 점수 보기',
    viewMyScores: '내 점수 보기',
    yourScore: '내 점수',
    skillOverwiev: '영역별 개요',
    tipsAndRecommendations: '팁 및 추천',
    readSample: '읽기 샘플',
    listentoSample: '샘플 듣기',
    certificateOverallHeader: '영어 능력',
    sampleResponseTitle: '{{firstName}} 님의 샘플 답변',
    samplePreviewDescription: '아래는 {{fullName}} 님의 {{skill}} 샘플입니다',
    emailPreview: '이메일 미리보기',
    shareResult: '결과 공유하기',
    shareYourResults: '내 결과 공유하기',
    shareYourResultsHeader: '누구와 점수를 공유하시겠어요?',
    shareYourResultsDescription:
      '플랫폼을 통해 점수를 공유하기로 선택하는 경우, 학습자님이 지정한 대상은 다음 정보에 액세스할 수 있습니다.',
    shareYourResultsCopyOfCertificate: '학습자님의 성적증명서 사본',
    shareYourResultsSamples: '학습자님의 말하기 및 쓰기 샘플',
    organizationName: '기관 이름',
    emailAddress: '이메일 주소',
    yourScoreHasBeenSent:
      '학습자님이 제공하신 이메일 주소로 학습자님의 점수가 전송되었습니다. 점수가 조회되면 학습자님에게 이메일로 알림이 전송됩니다.',
    previewTheEmailLinkDescription: '전송한 이메일은 클릭하여 미리보기할 수 있습니다',
    invalidEmailAddress: '잘못된 이메일 주소',
    previewEmail: '이메일 미리보기',
    shareResults: '결과 공유하기',
    atLevel: '수준에 부합',
    aboveLevel: '수준 이상',
    noTestsDescription: '시험을 마치면 여기에 점수가 표시됩니다.',
    belowLevel: '수준 미만',
    levelScale: [
      '입문(Beginner) 미만',
      '입문(Beginner)',
      '초급(Elementary)',
      '중급(Intermediate)',
      '중상급(Upper intermediate)',
      '고급(Advanced)',
      '전문가(Mastery)'
    ],
    highlightedScores: '*강조 표시된 점수는 <span>MyTopScore</span>를 산출하는 데 사용되었습니다.',
    credlyBadgeDialogTitle: '내 Credly 배지 받기',
    credlyBadgeDialogRedeemedTitle: '내 Credly 배지 공유하기',
    credlyBadgeDialogRedeemedDescription: '축하합니다, 학습자님은 Credly 배지를 받으셨습니다.',
    credlyBadgeDialogDescription:
      '축하합니다! 학습자님은 최근 치르신 {{productName}} 시험 결과에 대해 Credly 배지를 획득하셨습니다.',
    credlyBadgeDialogRedeemedListDescription:
      'Credly 프로필에 로그인하여 학습자님의 실력을 공유하세요!',
    credlyBadgeDialogListDescription: '간편한 3가지 단계를 따라 배지를 공유하세요.',
    credlyBadgeDialogSteps: [
      'Credly에서 발송한 이메일을 찾으세요',
      '이메일의 링크를 사용하여 Credly 프로필을 생성하고 배지를 받으세요',
      '그런 다음 배지를 공유하여 모두에게 학습자님의 실력을 보여주세요!'
    ],
    credlyBadgeDialogButton: 'Credly에 대해 자세히 알아보기',
    credlyBadgeDialogRedeemedButton: 'Credly로 이동하기',
    noResultsText: '시험을 마치면 여기에 점수가 표시됩니다.',
    shareResultsEmailSentSuccess: '성공!',
    yourScores: '내 점수',
    couldNotBeCertified: '학습자님의 시험 결과를 인증할 수 없습니다',
    retakeCompleted: '이 재시험은 완료되었습니다',
    seeAllResults: '모든 결과 보기'
  },
  testID: '시험 ID',
  testName: '시험 이름',
  shareDetails: {
    sharedWith: '공유 대상',
    sharing: '공유 중',
    name: '이름',
    shareDetailsHeaders: ['시험 ID', '공유일', '점수', '공유 대상', '공유 중']
  },
  menuLabels: {
    dashboard: '대시보드',
    results: '결과',
    account: '계정',
    gettingReady: '시험 준비하기',
    helpCenter: '지원 센터',
    exploreTests: '시험 소개',
    contactUs: '문의하기',
    logOut: '로그아웃'
  },
  speaking: '말하기',
  listening: '듣기',
  reading: '읽기',
  writing: '쓰기',
  dontHaveAnyTests: '보유한 시험이 없습니다',
  share: '공유',
  rowsPerPage: '페이지당 행',
  english: '영어',
  japanese: '일본어',
  korean: '한국어',
  date: '날짜',
  expirationDate: '만료일',
  account: {
    dontHaveAnyTestsWithShares: '점수를 공유하면 이 섹션에 그 내용이 표시됩니다',
    account: '계정',
    accounts: '계정',
    off: '끄기',
    on: '켜기',
    areYouSure: '확실한가요?',
    yesRevoke: '네, 취소합니다',
    cancel: '취소'
  },
  pagination: {
    of: '/'
  },
  view: '보기',
  noSampleTextToPreview: '미리보기할 샘플 텍스트가 없습니다.',
  done: '완료',
  thisShouldBeAValidEmailAddress: '유효한 이메일 주소여야 합니다',
  send: '전송',
  here: '여기',
  success: '성공',
  score: {
    header: '점수',
    scoreReportHeader: '성적증명서',
    scores: '점수',
    lookup: '성적증명서 검색'
  },
  play: '재생',
  exam: {
    speakLabel: '말하기...',
    listenLabel: '듣기...',
    fetch: '시험 가져오기'
  },
  layout: {
    next: '다음',
    back: '뒤로',
    agree: '동의하고 계속하기'
  },
  directoryLayout: {
    startTest: '시험 시작하기',
    exitTest: '시험 종료하기'
  },
  ageRestriction: {
    title: '연령 제한',
    thankYouForInterest:
      '관심을 가져 주셔서 감사합니다. 연령 제한으로 인해 아쉽게도 학습자님은 {{productName}} 시험을 사용하실 수 없습니다.',
    pleaseNote: '계정을 생성하려면 15세 이상이어야 합니다.',
    backToHomepage: '홈페이지로 돌아가기'
  },
  signUp: {
    header: '가입하고 <br />내 영어 실력을<br /> 인증하세요',
    mobileHeader: '가입하고 내 영어 실력을 인증하세요',
    advantages: [
      '무료로 제공되는 모의고사를 치러보세요!',
      '준비됐다는 생각이 들면 시험을 주문하고 치르세요',
      '48시간 후 인증된 결과를 공유하세요'
    ],
    description: '이제 한 단계만 더 거치면 계정을 통해 제공되는 모든 혜택을 누리실 수 있습니다',
    shouldBeValidEmail: '유효한 이메일 주소여야 합니다',
    withGoogle: 'Google로 가입하기',
    orSignUpWith: '또는 다음으로 가입하기',
    password: '비밀번호',
    privacyPolicy: '개인정보처리방침',
    charactersLength: '8자',
    consentLabel: '본인은 이용 약관을 읽고 여기에 동의하며 개인정보처리방침을 확인했습니다.',
    offersDescription:
      '학습자님의 프로필과 환경설정을 토대로 맞춤형 혜택을 전송해 드리고자 합니다.',
    offersConsentLabel: '이메일로 맞춤형 혜택을 받아보겠습니다.',
    consentSummaryDescription: '생각이 바뀌시면 언제든 구독 해지하실 수 있습니다.',
    agreeingText: '가입하기"를 클릭함으로써 학습자님은',
    cookiePolicy: '<a>쿠키 정책에</a> 동의하게 됩니다',
    alreadyHaveAccount: '이미 계정을 생성하셨나요?',
    signIn: '로그인',
    agreementsDescription:
      '당사의 <termsOfUseComponent>이용 약관</termsOfUseComponent>과 당사가 학습자의 정보를 사용하는 방식을 설명한 <privacyPolicyComponent>개인정보처리방침</privacyPolicyComponent>을 읽어 보시기 바랍니다.',
    termsOfUse: '이용 약관',
    consentIsMandatory: '필수 동의 사항',
    agreeToAll: '전체 이용약관에 동의',
    agreementTitle: '동의 확인 및 개인정보처리방침 검토',
    ageConsent: '본인은 만 14세 이상입니다.',
    collectUIIConsentTooltip:
      '당사는 신원 도용사기 방지를 위한 철처한 본인 확인을 위해 주민등록증 또는 여권, 신분증과 일치하는 얼굴 사진과 같은 고유 식별 정보를 수집합니다.',
    collectSIConsentTooltip:
      '당사는 본인 확인 용도로만 사용자의 음성 및 이미지 샘플을 포함한 생체 정보를 수집합니다. 이를 통해 응시자의 이미지와 음성을 신원이 확인된 사람의 이미지와 음성과 대조하여 사기를 방지합니다. 이는 시험을 공정하고 안전하게 실시하기 위해 필수적인 과정입니다.',
    provisionPIConsentTooltip:
      '당사는 서비스 제공 및 품질 향상을 위해 신뢰할 수 있는 파트너사에게 특정 개인 정보를 공유합니다. 귀하의 정보가 어떻게 사용되는지에 대한 자세한 내용을 확인하려면 여기를 클릭하세요.',
    transferPIConsentTooltip:
      '귀하의 정보는 미국으로 전송되고 저장되며, 서비스 제공을 위해 전 세계적으로 필요한 경우 Pearson 직원이 액세스할 수 있습니다. 개인정보 전송에 대한 자세한 내용을 확인하려면 여기를 클릭하세요.',
    marketingPurposesConsentTooltip:
      '동의하면 귀하는 당사가 마케팅 목적으로 귀하의 개인정보를 수집 및 사용하고, Pearson의 맞춤형 업데이트, 프로모션 및 제안을 귀하에게 발송하는 것을 허용하게 됩니다. 귀하는 이메일에 포함된 링크를 클릭해 언제든지 구독을 취소할 수 있습니다.',
    countrySpecificPolicies: '동의 확인',
    beforeProceed: '진행하기 전에...',
    differentCountryDetected:
      '다른 국가/지역에 계신 것 같습니다. 다음 국가별 이용약관 및 개인정보처리방침에 동의해 주십시오.',
    termsAndUseConsent: '<consentLink>이용약관</consentLink>에 동의합니다.',
    collectPIConsent: '<consentLink>개인정보 수집 및 이용</consentLink>에 동의합니다.',
    collectUIIConsent: '고유 식별 정보 수집 및 이용에 동의합니다.',
    collectSIConsent: '민감 정보 수집 및 이용에 동의합니다.',
    provisionPIConsent:
      '<consentLink>지정된 제삼자에게 개인정보를 제공하는 것</consentLink>에 동의합니다.',
    transferPIConsent: '<consentLink>개인정보 해외 이전</consentLink>에 동의합니다.',
    marketingPurposesConsent: '마케팅 목적으로 개인정보를 수집 및 이용하는 것에 동의합니다.',
    marketingEmailConsent:
      '이메일을 통해 맞춤형 오퍼 및 마케팅 커뮤니케이션을 수신하는 것에 동의합니다.'
  },
  versantByPearson: 'VERSANT BY PEARSON ENGLISH CERTIFICATE',
  downloadPearsonEnglishSkillsCertificate: '시험을 치르려면 {{productName}} 앱을 다운로드하세요.',
  signIn: {
    headerWeb: '돌아오신 걸 <br /> 환영합니다!',
    description:
      '이제 한 단계만 더 거치면 계정을 통해 제공되는<br/> 모든 혜택을 누리실 수 있습니다',
    signUpAndCertify: '가입하고 내 영어 능력 수준 인증받기',
    signInWithGoogle: 'Google로 로그인',
    orSignInWith: '또는 다음을 사용하여 로그인',
    emailOrPasswordErrorMessage: '잘못된 이메일 및/또는 비밀번호입니다. 다시 시도해 주세요. 또는',
    resetPassword: '비밀번호를 잊으셨나요?',
    advantages: ['시험 접수하기', '모의고사 치르기', '결과 보기', '내 최고 점수 공유하기'],
    dontHaveAccountYet: '아직 계정이 없으신가요?'
  },
  startYourLanguageJourneyHere: '여기에서 어학 여정을 시작하세요',
  join: '가입하기',
  signInText: '로그인',
  thisIsRequired: '필수 필드입니다',
  invalidEmail: '잘못된 이메일 주소',
  email: '이메일',
  fieldIsRequired: '필수 필드입니다',
  password: '비밀번호',
  signUpText: '가입',
  createAnAccount: '계정 만들기',
  watchTheVideo: '동영상 시청',
  resetPassword: {
    oldPasswordNotMatch: '이전 비밀번호가 일치하지 않습니다!',
    sameOldPassword: '새 비밀번호와 이전 비밀번호가 동일해서는 안 됩니다.',
    chooseAnotherPassword: '이미 사용된 비밀번호입니다. 다른 비밀번호를 입력해 주세요.',
    header: '비밀번호 재설정하기',
    sendLink: '링크 전송하기',
    rememberedPassword: '갑자기 비밀번호가 생각나셨나요?',
    checkYourEmail: '잘 됐네요! 이제 이메일을 확인해 보세요',
    sentLinkMessage:
      '입력하신 이메일이 유효한 사용자 계정과 연결되어 있는 경우, 곧 이메일이 전송됩니다. 이메일의 링크를 사용하여 새 비밀번호를 생성하고 프로필에 액세스하세요.',
    signUpFirst: '이메일을 받지 못하셨다면 먼저 <a>가입</a>해 주세요.',
    backToSignIn: '로그인으로 돌아가기',
    notToWorryText:
      '걱정 마세요, 다들 한 번쯤은 겪는 일이니까요! 아래에 이메일 주소를 입력하시면 재설정 링크를 전송해 드릴게요.',
    nCharacters: '{{n}}자',
    confirmPassword: '비밀번호 확인',
    passwordsMustBeEqual: '비밀번호와 비밀번호 확인 란은 일치해야 합니다',
    updatePassword: '비밀번호 업데이트',
    passwordHasBeenUpdated: '비밀번호가 업데이트되었습니다!',
    signInToAccount:
      '아래에서 이메일과 새 비밀번호를 사용하여 계정에 로그인하고 시험, 점수, 프로필에 액세스하세요.',
    createNewPassword: '새 비밀번호 만들기',
    settingNewPasswordDescription: '아래에서 새 비밀번호를 만들고 계정을 계속 이용하세요.'
  },
  atLeast: '최소',
  oneLowercaseLetter: '소문자 1자',
  oneUppercaseLetter: '대문자 1자',
  oneNumber: '숫자 1개',
  specialCharacter: '특수문자 1개',
  tellUsMoreForm: {
    getToKnowYou: '학습자님 알아가기',
    tellUsMore: '저희에게 학습자님에 대해 조금 더 알려주세요',
    preferredName: '선호하는 이름',
    fieldRequired: '필수 필드입니다',
    age: '나이',
    country: '거주 국가',
    city: '거주 도시',
    next: '다음',
    describe: '다음 중 학습자님에 가장 부합하는 설명은 무엇인가요?',
    done: '모두 마치셨습니다. 감사합니다!',
    getReady: '시험 준비하기',
    iAmStudent: '대학생 또는 전문대학생',
    iAmGraduate: '학사',
    iAmYoungProfessional: '젊은 전문가',
    iAmProfessional: '중견/시니어 전문가',
    iAmSecondaryStudent: '중고교생'
  },
  and: '그리고',
  changePassword: {
    alreadyUsedPasswordError: '이미 사용된 비밀번호입니다. 다른 비밀번호를 입력해 주세요.',
    oldPasswordDoesntMatchError: '이전 비밀번호가 일치하지 않습니다!',
    oldAndNewPasswordsAreEqualError: '새 비밀번호와 이전 비밀번호가 일치해서는 안 됩니다.',
    confirmPasswordError: '확인된 비밀번호와 새 비밀번호가 동일하지 않습니다!',
    youCanNowCreate: '이제 아래에서 새 비밀번호를 만드실 수 있습니다.',
    oldPassword: '기존 비밀번호',
    newPassword: '새 비밀번호',
    confirmPassword: '비밀번호 확인',
    resetYourPassword: '비밀번호 재설정',
    save: '저장',
    success: '성공!',
    passwordChanged: '비밀번호가 성공적으로 변경되었습니다.',
    forgotYourPassword:
      '비밀번호를 잊으셨나요? 걱정 마세요, 다들 한 번쯤은 겪는 일이니까요! 아래에 이메일 주소를 입력하시면 재설정 링크를 전송해 드릴게요.',
    sendLink: '링크 전송하기',
    email: '이메일',
    checkEmail: '잘 됐네요! 이제 이메일을 확인해 보세요',
    weHaveSentLink:
      '비밀번호 재설정 링크를 전송해 드렸습니다. 이메일의 링크를 사용하여 새 비밀번호를 만들고 계정에 액세스하세요'
  },
  exploreTestsPage: {
    exploreResources: '시험 준비하기',
    exploreResourcesButton: '시험 자료 둘러보기',
    watchOurWalkthroughs:
      '단계별 안내를 제공하는 동영상을 시청하고, 시스템 요구사항을 확인하거나 자주 묻는 질문(FAQ)을 둘러보세요',
    englishSkillsCertificate: '영어 영역별 성적증명서 - 4개 영역',
    listeningAndSpeaking: '말하기 & 듣기',
    readingAndWriting: '읽기 & 쓰기',
    practiceForFree: '무료로 연습하기',
    buyNow: '지금 결제하기',
    checkYourTest: '시험 응시 전 체크 리스트',
    takeTest: '필요한 사항',
    chooseYourTest: 'Pearson 영어 시험',
    tagsAll: ['말하기', '듣기', '읽기', '쓰기'],
    tagsListeningSpeaking: ['말하기', '듣기'],
    tagsReadingSpeaking: ['읽기', '쓰기'],
    ourEnglishSkillsCertificate:
      '<bold>{{productName}}™</bold>를 이용하면 실력 입증이 필요한 영어 영역만 평가를 받을 수 있는 유연성을 누릴 수 있습니다.',
    exploreTestsWrapperTypeOfTestsHeader: '4개 영역 모두의 영어 실력 인증',
    forSuccessfulTest:
      '시험을 치르기에 앞서 모든 준비를 마쳤는지 확인하세요! 다음은 시험에 필요한 요건입니다.',
    checkSystemReq: '시스템 요구사항 확인하기',
    twoSkillsTests: '또는 2개 영역 인증하기',
    requirements: {
      system: '시스템',
      checkYourSetUp: '학습자는 빠르게 ',
      quickSystemCheck: '시스템 체크를 수행할 수 있습니다',
      windowOrMacComp: 'Windows 또는 Mac 컴퓨터',
      speakerOrMicrophone: '스피커 및 마이크',
      reliableInternet: '안정적인 인터넷',
      security: '보안',
      governmentId: '정부 발급 신분증 - 여권 또는 운전면허증 권장',
      singleMonitor: '단일 모니터 또는 디스플레이 - 그외의 디스플레이는 비활성화 필요',
      frontFacingCamera: '전면 카메라',
      environment: '환경',
      sixtyMinutes: '최대 60분(선택한 시험에 따라 상이함)',
      quietWellLit: '밝은 조명이 있는 공간',
      privateSpaceWith: '프라이버시 - 혼자이며 방해받지 않아야 함'
    },
    min: '분'
  },
  languageSwitcher: {
    ENG: '영어',
    JPN: '일본어',
    KOR: '한국어',
    english: '영어',
    japanese: '일본어',
    korean: '한국어'
  },
  takenOn: '응시일',
  validThrough: '유효기간:',
  homePage: {
    cta: {
      text: '지금 바로 영어 실력을 인증하세요',
      describe: '언제든지 1시간가량 소요되는 시험을 치르고 몇 분 만에 정확한 결과를 받아보세요'
    },
    ctaFlexible: {
      text: '나에게 필요한 시험 알아보기 ',
      describe:
        '읽기, 쓰기, 말하기, 듣기 중 본인에게 필요한 영역의 시험만 응시하거나, 4개 영역 시험 모두에 응시하세요!'
    },
    ctaMyTopScore: {
      text: 'MyTopScore 자랑하기',
      describe:
        'MyTopScore 기능을 통해 최고의 성적을 공유할 수 있습니다.<margin /> 두 개 이상의 시험에 응시한 경우, 각 시험 영역에서 받은 최고 점수를 자동으로 선택하여 다른 응시자들보다 뛰어난 성적으로 돋보일 수 있습니다.'
    },
    ctaShowYourCredly: {
      text: 'Credly 디지털 배지 획득하기',
      describe:
        '<bold>{{productName}}</bold> 시험을 치르면 공식 Credly 배치도 획득할 수 있습니다. 이력서, 이메일 서명, 소셜 미디어 프로필, 온라인 포트폴리오에 Credly 배지를 추가하여 실생활에서 활용할 수 있는 영어 실력을 갖추었음을 주변 사람들에게 알리세요.'
    },
    enterYourEmail: '이메일 입력',
    exploreTests: '시험 소개',
    discoverCredly: 'Credly 둘러보기',
    exploreResources: '리소스 둘러보기',
    learnAboutTopscore: 'MyTopScore 자세히 알아보기',
    pearsonTestsAreTrusted: '유수의 기관과 기업에서 신뢰하는 Pearson 시험',
    fasterWayToShowEmployers: '{{productName}} 시험은...',
    featuresOfProduct: {
      fastTitle: '신속성',
      fastDescription:
        '몇 분 만에 결과를 확인하고, 48시간 이내에 공유할 수 있는 공인 점수를 받아볼 수 있습니다',
      convenientTitle: '편리함',
      convenientDescription:
        '별도의 시험장이 없어 방문할 필요가 없습니다. 언제 어디서든 온라인으로 시험에 응시하세요',
      authenticTitle: '진정성',
      authenticDescription:
        '시험을 통과할 수 있는 역량이 아닌 진정한 영어 의사소통 실력을 평가 할 수 있습니다'
    }
  },
  allRightsReserved: '© 2023 Pearson 모든 권리 보유.',
  footerLinks: {
    termsOfUse: '이용 약관',
    privacy: '개인정보처리방침',
    cookies: '쿠키'
  },
  generatedOn: '생성일:',
  shareOnCredly: '내 Credly 배지',
  skillsLabel: '영역',
  myOverallProficiency: '종합 능력',
  gseScore: '종합 점수',
  profilePage: {
    automaticShareInfoTooltip:
      '활성화 코드에 기반해 시험이 진행되었기 때문에 해당 점수는 자동으로 기관에 공유되었습니다.',
    denied: '거부됨',
    close: '닫기',
    profileTab: '프로필',
    orderHistoryTab: '주문 내역',
    sharedScoresTab: '공유된 점수',
    searchPlaceholder: '검색',
    allSentScores: '내가 공유한 점수',
    backToAllSentScores: '내가 공유한 점수로 돌아가기',
    turnSharingOff: '공유 중지하기',
    shareDetailsTooltipTitle:
      '동의를 철회하면 학습자님의 점수에 액세스할 수 있던 모든 이메일이 더 이상 학습자님의 성적증명서를 조회할 수 없습니다. 이 조치는 실행 취소할 수 없습니다.',
    scoreNotAvailable: '당초 점수를 공유했던 수신자들이 더 이상 다음 점수에 액세스할 수 없습니다',
    scoresTableHeaders: ['기관', '이메일', '공유일', '상태'],
    dateShared: '공유일',
    email: '이메일',
    allOrderHistoryTableHeaders: ['주문 이름', '구입일', '주문 상태', '총결제액', ' '],
    allOrderHistoryTableHeadersShortcut: ['주문 이름', '', '', '총결제액'],
    allSentScoresTableHeaders: ['시험 이름', '시험 ID', '점수', '생성일', '공유 대상'],
    viewed: '조회됨',
    notViewed: '조회되지 않음',
    dontHaveAnyHistoryOrders: '주문 내역이 없습니다',
    requestRefund: '환불 요청하기',
    processingOrder: '주문을 처리 중입니다...',
    youAreAllSet: '환불을 개시했습니다',
    noLongerRefundable: '이 시험은 환불할 수 없습니다',
    noAvailableTestsForRefund: '환불할 수 있는 시험이 없습니다',
    testsAlreadyRefundedDescription: '이 주문은 이미 환불 처리되었습니다',
    refundInProgressTitle: '또 다른 환불을 요청하려 하시나요?',
    refundInProgressDescription:
      '이 주문의 경우, 당사에서 학습자님의 앞선 환불 요청을 완료할 때까지 기다려 주시기 바랍니다',
    testsExpiredForRefundDescription: '이 주문의 시험은 이미 수험했거나 만료되었습니다',
    cannotRequestARefund:
      '시험 접수 및 결제 후 90일이 경과했거나 이미 시험을 시작한 경우 환불을 받으실 수 없습니다 ',
    requestARefund: '환불 요청하기',
    jitNotice: '시험이 시작되어 환불이 불가합니다.',
    downloadReceipt: '영수증 다운로드',
    weHaveInitiatedYourRefund:
      '이용하시는 은행에 따라 계좌에 금액이 표시되기까지 최대 10일이 걸릴 수 있습니다',
    selectProducts: '취소하여 환불을 신청하고자 하는 항목을 선택하세요',
    paid: '결제 완료',
    fulfilled: '처리 완료',
    refunded: '환불 완료',
    partiallyRefunded: '일부 환불 완료',
    error: '오류',
    done: '완료',
    refund: '환불 요청하기',
    pending: '보류 중',
    titleAllOrders: '주문 내역',
    recentOrders: '최근 주문',
    accordionHeaders: ['항목', '수량', '비용', ' '],
    accordionHeadersShortcut: ['항목', '비용'],
    refundPopupHeaders: ['항목', '구입일', '비용'],
    basicInformation: '기본 정보',
    edit: '수정',
    demographicDetails: '인구통계학적 상세정보',
    fullName: '성명',
    dateOfBirth: '생년월일',
    gender: '성별',
    countryOfResidence: '거주 국가',
    cityOfResidence: '도시',
    citizenship: '국적',
    languages: '언어',
    securityAndPrivacy: '보안 및 개인정보 보호',
    managePasswordHeader: '비밀번호 관리',
    managePasswordText: '비밀번호 변경',
    privacyPolicyHeader: '개인정보처리방침',
    privacyPolicyText: 'Pearson 온라인 제품 개인정보처리방침 검토하기',
    termsOfUseHeader: '이용 약관',
    termsOfUseText: 'Pearson 온라인 제품 이용 약관 검토하기',
    editProfileTitle: '프로필 정보 수정하기',
    changeYourPassword: '비밀번호 변경',
    editProfileWebTips:
      '<p><bold>이름:</bold> 신분증에 기재된 이름, 가운데 이름, 그 밖의 모든 이름을 입력하세요.</p> <p><bold>성:</bold> 신분증에 기재된 성을 정확하게 입력하세요.</p>',
    editProfileFormDescription:
      '시험에 응시하려면 사진이 부착된 유효한 신분증이 있어야 합니다. 신분증에 기재된 이름을 <bold>정확하게</bold> 입력해 주세요. 신분증이 영문이 아니더라도 걱정하지 마세요! 신분증이 발급된 언어로 이름을 입력하세요.',
    editProfileFormGivenName: '이름',
    editProfileFormGivenNameTooltip:
      '이름은 정부에서 발급한 신분증에 기재된 것과 정확하게 일치해야 합니다.',
    editProfileFormSurname: '성',
    editProfileFormSurnameTooltip:
      '성은 정부에서 발급한 신분증에 기재된 것과 정확하게 일치해야 합니다.',
    countryOfCitizenship: '국적',
    countryOfCitizenshipTooltip:
      '국적은 시험 도중에 제출할 신분증에 기재된 국적과 일치해야 합니다.',
    startTypingPlaceholder: '입력을 시작하세요...',
    editProfileFormEmail: '이메일',
    next: '다음',
    firstLanguage: '모국어',
    scoreSharingHeader: '점수 공유 상세정보',
    sharedWithPeople_zero: '0명',
    sharedWithPeople_one: '1명',
    sharedWithPeople_other: '{{count}}명'
  },
  noOptions: '옵션 없음',
  english4SkillsTestName: 'English Certificate | 4개 영역',
  myTopScoreSeparated: '내 최고 점수',
  yourTopScoreIsCalculatedFrom:
    '학습자님의 <boldItalic>MyTopScore</boldItalic>는 각 영역별 최고 점수를 사용해 산출됩니다. 시험을 치르고 여기에서 학습자님의 최고 점수를 확인하세요!',
  dashboardPage: {
    welcome: '<highlight>{{name}}</highlight> 님, 환영합니다',
    welcomeTitle: '{{name}} 님, 환영합니다',
    welcomeBack: '<highlight>{{name}}</highlight> 님, 돌아오신 걸 환영합니다',
    welcomeBackTitle: '{{name}} 님, 돌아오신 걸 환영합니다!',
    headerText: '이제 몇 단계만 더 거치면 <bold>영어 실력을</bold>인증하실 수 있어요!',
    beforeStartModalSubtitle: '무료로 연습하기',
    beforeStartModalTitle: '시작하기 전에',
    beforeStartModalText: '시험에 응시하려면 다음을 준비해야 합니다.',
    beforeStartModalTextPractice: '모의고사에 응시하려면 다음을 준비해야 합니다.',
    beforeStartModalText2: '준비되셨나요? 컴퓨터에 시험 애플리케이션을 다운로드하고 설치하세요.',
    beforeStartModalListItem1: '시험 애플리케이션 다운로드 <bold>(2분)</bold>',
    beforeStartModalListItem2: '시험 환경 설정 <bold>(2분)</bold>',
    beforeStartModalListItemPractice3: '모의고사 응시 <bold>(15~30분)</bold>',
    beforeStartModalListItem3: '시험 응시 <bold>(30~60분)</bold>',
    backToDashboard: '대시보드로 돌아가기',
    retakeTestButton: '재시험 치르기',
    finalParagraph: '준비되셨나요? 컴퓨터에 시험 애플리케이션을 다운로드하고 설치하세요.',
    finalParagraphProductName:
      '준비되셨나요? 컴퓨터에 <bold>{{productName}}</bold> 애플리케이션을 다운로드하고 설치하세요.',
    beforeStartModalButton: '애플리케이션 다운로드',
    retake: '재시험',
    SoftProfileAllDoneText:
      '시험에 응시하려면 사용하는 데스크톱에 <bold>English Certificate</bold> 앱을 다운로드해야 합니다.',
    SoftProfileAllDoneButton: '대시보드로 이동하기',
    getReady: '시험 준비하기',
    youAreAllDone: '모두 마치셨습니다. 감사합니다!',
    accordionTitle: '영어 시험 접수 및 결제하기',
    accordionSubtitle: '실력 입증이 필요한 영역 인증받기',
    accordionPracticeTitle: '무료로 연습하기',
    accordionPracticeSubtitle: '모의고사 치르기',
    accordionTakeTestTitle: '시험 응시',
    accordionTakeTestButtonText: '시험 시작하기',
    accordionLatestTestResult: '최근 시험: <span>{{score}}</span>점',
    accordionShareResultsTitle: '결과 공유하기',
    accordionShareResultsSubtitle: '결과를 기관에 전송하고 Credly 배지를 공유하세요 ',
    accordionLatestTestTitle: '결과 보기',
    badgeMyTopScore: '내 최고 점수',
    badgeValidThrough: '유효기간: <bold>{{date}}</bold>',
    badgeViewDetails: '세부정보 보기',
    badgeNoTopScoreText:
      '학습자님의 <bold>MyTopScore</bold>는 각 영역별 최고 점수를 사용해 산출됩니다. 시험을 치르고 여기에서 학습자님의 최고 점수를 확인하세요!',
    credlyBadgeTitle: '내 Credly 배지 받기',
    credlyBadgeTitleRedeemed: '내 Credly 배지 공유하기',
    credlyBadgeLi1: 'Credly에서 발송한 이메일을 찾으세요',
    credlyBadgeLi2: '이메일의 링크를 사용하여 Credly 프로필을 생성하고 배지를 받으세요',
    credlyBadgeLi3: '그런 다음 배지를 공유하여 모두에게 학습자님의 실력을 보여주세요!',
    credlyBadgeButtonRedeemed: 'Credly로 이동하기',
    credlyBadgeButton: 'Credly에 대해 자세히 알아보기',
    credlyBadgeRedeemedCongratulationsText: '축하합니다, 학습자님은 Credly 배지를 받으셨습니다.',
    credlyBadgeRedeemedCongratulationsTextLine2:
      '이제 다른 사람들과 공유해 보세요! 시작하려면 Credly 프로필로 이동하시면 됩니다.',
    credlyBadgeTaketestToGetCredly:
      '시험을 치르고 Credly 배지를 획득하여 다른 사람들과 공유해 보세요!',
    takeTestAccordionNoTestsText: '시험을 접수 및 결제하고 영어 실력을 인증해 보세요',
    takeTestAccordionAvailableTestsTitle: '이용 가능한 시험 <span>{{availableTests}}개</span>',
    takeTestAccordionSignInButton: '시험 둘러보기 ',
    formDownloadAccordionTitle: '시작하기 전에',
    formDownloadAccordionSubtitle: '시험 치르기',
    formDownloadAccordionPracticeSubtitle: '무료로 연습하기',
    startJourneyStepperTitle: '시작하기',
    startJourneyStepperStep1Description: '시험 애플리케이션 다운로드',
    startJourneyStepperTimeRequired: '{{time}}분',
    startJourneyStepperStep2Description: ' 시험 환경 설정',
    startJourneyStepperStep3Description: '신원 확인',
    startJourneyStepperStep4Description: '시험 시작',
    latestTestBoxTitle: '최근 시험',
    fourSkillsTestTitle: '4개 영역 영어 능력 평가',
    practiceSubtitle: '무료로 연습하기',
    practiceTitle: '시작하기 전에',
    speakingAndListeningTestTitle: '말하기 & 듣기 시험',
    readingAndWritingTestTitle: '읽기 & 쓰기 시험',
    whatsNextTile: {
      whatYouCanDoNext: '그 다음 할 수 있는 일은 다음과 같습니다.',
      takePracticeTest: '모의고사 응시',
      buyATest: '시험 접수 및 결제',
      startTest: '시험 응시',
      viewResults: '결과 보기',
      shareResults: '결과 공유하기',
      redeemCode: '활성화 코드를 가지고 계신가요? <action>시험을 활성화하세요</action>'
    },
    min: '분',
    welcomeDialogPopupTitle: '{{productName}}에 오신 것을 환영합니다',
    resultsAccordionTableHeaders: ['시험', '날짜', '상태', '종합 점수', 'CEFR', ''],
    practiceTestLabelButtonText: '모의고사',
    productTileButtonText: '시작 준비 완료',
    identifyIntroSection: {
      whatYouNeed: '다음과 같은 항목이 필요합니다.',
      yourId: '수험자의 사진이 부착된 공식 신분증',
      governmentId:
        '이는 정부에서 발급한 신분증(예: 주민등록증 또는 여권)을 말합니다. 최소 3개월 이상의 유효 기간이 남은 신분증이어야 합니다.',
      mobilePhone: '스마트폰(선택사항) - 권장',
      weRecommend:
        '신분증 사진을 또렷하게 촬영하기 위해 웹캠보다는 스마트폰을 사용하실 것을 권장합니다.',
      nextPage: '다음'
    },
    practiceTestList: {
      errorMessage: '이용 가능한 모의고사를 가져오는 데 문제가 발생했습니다'
    },
    resultTestPanel: {
      errorMessage: '시험 결과를 가져오는 데 문제가 발생했습니다'
    },
    backToAllResults: '모든 결과로 돌아가기',
    shareScoresDownloadCertificate: '점수 공유하기/성적증명서 다운로드하기',
    startTest: '시험 시작하기',
    downloadScoreCard: '평가표 다운로드하기',
    buyTest: '시험 접수 및 결제하기',
    productTileCounter: '{{items}}개',
    seeAllResults: '모든 결과 보기',
    noScore: '점수 없음',
    redeemActivationCodeTile: {
      text: '<bold>활성화 코드</bold>를 가지고 계신가요? 아래에서 사용하여 시험을 시작하세요.',
      buttonText: '시험 활성화하기'
    }
  },
  helpCenterPage: {
    header: '지원 센터',
    headerText: '{{productName}} 시험 과정에 걸쳐 어떤 도움을 받으실 수 있는지 알아보세요.',
    sidebarText: '궁금한 점이 있으신가요? 언제든 <a>문의</a>하여 도움을 받으세요.',
    activeCategory: '시험 소개',
    categories: '카테고리'
  },
  survey: {
    caption1: '매우 나쁨',
    caption2: '나쁨',
    caption3: '좋음',
    caption4: '훌륭함!',
    caption5: '탁월함!!',
    subheader: '가시기 전에',
    header: '경험을 평가해 주세요',
    headerAlternative: '의견을 남겨 주셔서 감사합니다!',
    subheader2: '시험 경험이 어땠는지 알려 주세요',
    textFieldLabel: '더 자세히 알려 주세요',
    button: '제출',
    buttonAlternative: '대시보드로 이동하기',
    reason: {
      subheader: '의견 공유하기',
      header: '가시기 전에...',
      subheader2: '무슨 일인지 알려 주세요.',
      textFieldLabel: '공유하고 싶은 사항이 있으신가요?'
    },
    leaveOnEnvSetup: {
      reason1: '시험 설정 도중 문제가 발생했습니다',
      reason2: '지금 시험에 응시할 시간이 없습니다'
    },
    leaveOnIDVerification: {
      reason1: '신분증 확인 도중 문제가 발생했습니다',
      reason2: '지금 시험에 응시할 시간이 없습니다'
    }
  },
  dateGenerated: '생성일',
  sharedWith: '공유 대상',
  testCode: '시험 코드',
  testTakerId: '수험자 ID',
  stopSharing: '공유 중지하기',
  allSharedScores: '공유된 모든 점수',
  allScoresYouShared: '내가 공유한 모든 점수',
  doYouWantStopSharing:
    '<bold>MyTopScore</bold> 공유를 중지하시겠어요? 확인을 클릭하면 기존에 학습자님의 성적증명서를 수신한 모든 선택된 연락처가 더 이상 성적증명서에 액세스할 수 없게 됩니다. 이 조치는 실행 취소할 수 없습니다.',
  orderConfirmation: {
    thanksForPurchase: '결제해 주셔서 감사합니다!',
    yourOrderNumberIs: '학습자님의 주문 번호는 <bold>{{orderNumber}}</bold>입니다.',
    weHaveSentYouConfirmationEmail:
      '학습자님이 치르실 시험 관련 중요한 정보를 포함한 이메일 확인서를 전송해 드렸습니다. 주문과 관련하여 궁금한 점이 있는 경우 <a>이 양식</a>을 통해 문의하시기 바랍니다.',
    fromDashboardYouCan:
      '학습자님의 시험이 대시보드에 표시되려면 몇 분 정도 걸릴 수 있습니다. 대시보드에서 할 수 있는 일',
    viewOrderHistory: '<bold>내 주문 내역 보기</bold> - 계정 페이지로 이동하여 "주문"을 선택하세요',
    takeATest:
      '<bold>시험 응시</bold> - 시험 애플리케이션을 아직 설치하지 않은 경우 설치가 필요합니다',
    goToDashboard: '대시보드로 이동하기',
    viewOrderHistoryButton: '주문 내역 보기',
    errorTitle: '이런!',
    errorMessage: '잘못된 링크를 선택하신 것 같습니다. 다시 시도해 주세요.'
  },
  processingOrderBanner: {
    description:
      '학습자님의 최근 주문을 처리하고 있습니다. 구입한 내역을 나중에 다시 확인하세요...',
    orderId: '주문 ID:',
    dateOfPurchase: '결제일:'
  },
  gettingReadyPage: {
    heroHeader: '영어 실력을 뽐내기 위해 필요한 모든 것',
    heroText:
      '학습자님이 최상의 시험 환경을 누릴 수 있도록 도움을 제공하는 무료 자료를 살펴보세요.',
    heroPracticeButtonText: '모의고사 시작하기',
    heroDownloadButtonText: '시험대비서 다운로드하기',
    getStartedHeader: '시작하기',
    getStartedText: '단계별로 시험 과정에 대해 알아보세요.',
    getStarted1Title: '시험 준비하기',
    getStarted1Link: '준비 사항 살펴보기',
    getStarted1Points: [
      '무료 계정 생성하기',
      '컴퓨터에 시험 앱 다운로드하기',
      '무료로 필요한 만큼 시험 대비 연습하기',
      '시험대비서 읽어보기'
    ],
    getStarted2Title: '시험 응시',
    getStarted2Link: '요건 확인하기',
    getStarted2Points: [
      '시험 응시료 결제',
      '준비가 되면 시험 앱 실행하기',
      '시험 응시 전 시험 환경 설정 및 신분증 확인 완료하기',
      '이제 시험을 치를 준비가 완료되었습니다! 시험을 완료하는 데는 최대 1시간이 소요됩니다'
    ],
    getStarted3Title: '시험 종료 후',
    getStarted3Link: '결과에 대해 더 자세히 알아보기',
    getStarted3Points: [
      '48시간 이내에 인증된 결과 확인',
      '지원할 기업에 성적증명서 공유',
      'Credly 배지 수령 및 공유'
    ],
    howToHeader: '안내 가이드 시청',
    howToVideo1Title: '시험 준비하기',
    howToVideo1Subtitle:
      '어떻게 시험을 접수하고 준비하며, 시험 애플리케이션을 다운로드받는지 알아보세요',
    howToVideo2Title: '시험 응시',
    howToVideo2Subtitle:
      '어떻게 시험을 시작하고 장비를 점검하며 신원을 확인하는지 그 방법을 알아보세요',
    howToVideo3Title: '결과 이해하기',
    howToVideo3Subtitle: '점수, 성적증명서, MyTopScore™에 대해 알아보세요',
    howToVideo4Title: '결과 공유하기',
    howToVideo4Subtitle: '기업과 기관에 성적증명서를 공유하는 방법을 알아보세요',
    prepareForTestHeader: '시험 준비하기',
    prepareForTestLeftHeader: '시험 연습하기',
    prepareForTestLeftText:
      '높은 점수를 얻기 위해 가장 좋은 방법은 연습입니다. 원하는 시간에 필요한 만큼 무료 모의고사에 응시하세요.',
    prepareForTestLeftButton: '무료 모의고사 응시하기',
    prepareForTestRightHeader: '시험대비서 읽기',
    prepareForTestRightText:
      '시험을 위한 궁극의 시험대비서입니다. 시험 준비, 환경 설정 안내와 점수 평가, 공유 방법도 포함되어 있습니다. 무료로 다운로드하세요.',
    prepareForTestRightButton: '시험대비서 다운로드하기',
    exploreTestHeader: '시험 문제 유형 둘러보기',
    exploreTestText: '시험 문제 유형을 익히고 문제에 답변하는 방법을 알아보세요.',
    exploreTestVideo1title: 'English Certificate | 4개 영역',
    exploreTestVideo1Description: '4개 영역 시험 동영상 살펴보기',
    exploreTestVideo2title: 'English Certificate | 말하기 & 듣기',
    exploreTestVideo2Description: '말하기 & 듣기 시험 동영상 살펴보기',
    exploreTestVideo3title: 'English Certificate | 읽기 & 쓰기',
    exploreTestVideo3Description: '읽기 & 쓰기 시험 동영상 살펴보기',
    systemRequirementsHeader: '시스템 요구사항 확인하기',
    systemRequirementsText:
      '시작하기 전에 시험을 성공적으로 치르기 위해 필요한 모든 것이 준비되었는지 확인하세요.',
    systemRequirementsItem1Title: '시스템',
    systemRequirementsItem1Line1: 'Windows 또는 Mac 컴퓨터',
    systemRequirementsItem1Line2: '스피커 또는 마이크',
    systemRequirementsItem1Line3: '안정적인 인터넷',
    systemRequirementsItem2Title: '보안',
    systemRequirementsItem2Line1: '정부 발급 신분증 - 여권 또는 운전면허증 권장',
    systemRequirementsItem2Line2: '단일 모니터 - 듀얼 스크린 셋업 비활성화 필요',
    systemRequirementsItem2Line3: '전면 카메라',
    systemRequirementsItem3Title: '환경',
    systemRequirementsItem3Line1: '60분 - 방해받지 않고 시험을 완료하기 위해 필요한 시간',
    systemRequirementsItem3Line2: '밝은 조명이 있는 공간',
    systemRequirementsItem3Line3: '다른 사람이 없는 사적인 공간',
    resultsHeader: '점수 확인 및 공유하기',
    resultsText:
      '저희는 고객과의 약속에 따라 48시간 이내에 점수를 인증해 드리므로 결과를 기다리느라 시간을 낭비하지 않으셔도 됩니다. 시험 인증을 받으려면 학습자님의 시험이 보안 확인을 통과해야 합니다. 지원센터와 공식 시험대비서를 통해 인증 정책에 대해 자세히 알아보세요.',
    resultsItem1Title: '1시간 이내',
    resultsItem1Subtitle: '예상 점수 보기',
    resultsItem1Description: '최종 보안 검사에 앞서 잠정 점수를 공유해 드립니다',
    resultsItem2Title: '48시간 이내',
    resultsItem2Subtitle: '점수를 인증받으세요',
    resultsItem2Description:
      '보안 확인을 마치는 대로 알려드립니다. 학습자님의 시험이 보안 요건을 충족하는 경우, 성적증명서를 결과 대시보드에서 확인하실 수 있습니다.',
    resultsItem3Title: '준비 완료!',
    resultsItem3Subtitle: '내 결과 공유하기',
    resultsItem3Description:
      '결과 대시보드에서 곧바로 기업에 점수를 공유하거나 성적증명서를 PDF로 다운로드하실 수 있습니다. 4개 영역을 모두 인증받은 경우 Credly 배지를 이용하실 수도 있습니다.',
    resultsTitle2: '편리한 MyTopScore',
    resultsText2:
      '가장 높은 점수를 표시해 드립니다. 성적증명서에는 지난 6개월 동안 말하기, 듣기, 읽기, 쓰기 영역에서 획득한 가장 높은 점수가 자동으로 표시됩니다. 자신감 있게 점수를 공유하세요.',
    resultsTitle3: 'Credly 배지 자랑하기',
    resultsText3:
      'MyTopScore를 이용하면 전 세계적으로 인정받는 디지털 Credly 배지를 받아 성취를 공유하고 자랑할 수 있습니다. 간단히 이력서에 추가하거나 소셜 미디어를 통해 공유하면, 지원 희망 기업에서 학습자님의 영어 실력을 간편하게 확인할 수 있습니다.',
    resultsButton: 'Credly에 대해 자세히 알아보기',
    faqHeader: '자주 묻는 질문',
    faqReadMore: '지원 센터에서 더 많은 질문 읽어보기',
    downloadDialogSubtitle: '시험 준비도',
    downloadDialogTitle: '시험 응시자용 시험대비서 다운로드',
    startTestDialogSubtitle: '시작하기 전에',
    startTestDialogTitle: '다음 몇 가지에 유념하세요...',
    startTestDialogParagraph1: '모의고사에 응시하려면 앞서 몇 가지 단계를 완료하셔야 합니다.',
    startTestDialogLi1: '계정 만들기',
    startTestDialogLi2: '시험 앱 다운로드',
    startTestDialogParagraph2: '모의고사의 경우 다음이 필요합니다.',
    startTestDialogLi3: 'PC 또는 Mac 컴퓨터',
    startTestDialogLi4: '전면 카메라',
    startTestDialogButtonClose: '닫기',
    startTestDialogButtonContinue: '계속',
    downloadPopupTitle: '애플리케이션 다운로드',
    downloadPopupSubtitle: '시험 준비하기',
    formDownloadTitle: '시험 응시',
    faqIAccordion1Title: '확인 시스템에서는 어떤 신분증을 허용하나요?',
    faqIAccordion1Description:
      '시험에 앞서 학습자는 아래에 설명된 요건을 충족하는 신분증(ID)을 제시해야 합니다.',
    faqIAccordion1List1: [
      '모든 신분증은 정부에서 발급한 유효한 원본이어야 합니다(즉, 사본 불가)',
      '신분증에는 수험자의 이름과 알아볼 수 있는 최근 촬영 사진이 포함되어야 합니다',
      '신분증의 성명이 프로필 정보에 등록한 성명과 일치해야 합니다',
      '유효기간이 만료된 신분증은 허용되지 않습니다'
    ],
    faqIAccordion1Description2: '허용되는 신분증 양식:',
    faqIAccordion1List2: [
      '해외여행용 여권',
      '운전면허증',
      '신분증(국가, 주 또는 지방에서 발급한 신분증)',
      '외국인 등록증(그린 카드 또는 영주권/비자)'
    ],
    faqIAccordion1Description3: '허용되지 않는 신분증:',
    faqIAccordion1List3: [
      '미국 국방성(DoD) 일반 출입 카드(CAC) 또는 특정 보안 출입 신분증을 포함한 제한된 신분증*',
      '{{productName}}이(가) 제한된 국가의 신분증: 북한, 쿠바, 시리아, 수단, 이란, 러시아, 벨라루스, 우크라이나 세바스토폴/크림반도'
    ],
    faqIAccordion1Description4:
      '*{{productName}}에서는 법적으로 복사 및 디지털화, 카메라 촬영이 금지된 제한된 신분증은 온라인 시험을 위한 신분증으로 인정하지 않습니다.',
    faqIAccordion2Title: '감독 창이란 무엇인가요?',
    faqIAccordion2Description:
      '시험이 진행되는 동안 감독 시스템이 부정행위나 의심스러운 행동이 발생하지 않았는지 수험자의 행동을 분석합니다. 시험 결과를 인증받으려면 감독 규정을 준수하셔야 합니다.',
    faqIAccordion2Description2: '다음 사항에 유념하시기 바랍니다.',
    faqIAccordion2List1: [
      '배경 소음이 없는 조용한 곳에서 시험에 응시하세요',
      '조명이 밝은 곳에서 시험에 응시하세요',
      '시험 기간 내내 혼자여야 합니다'
    ],
    faqIAccordion2Description3: '신분증:',
    faqIAccordion2Description4:
      'FAQ 섹션의 "허용되는 신분증 양식"에서 더 자세한 정보를 확인하실 수 있습니다',
    faqIAccordion2List2: [
      '계정 세부정보(이름, 성 등)가 정부에서 발급한 신분증에 기재된 정보와 일치해야 합니다.',
      '다른 사람의 개인 정보나 신분증을 사용해서는 안 됩니다.'
    ],
    faqIAccordion3Title: '내 시험이 "검토 보류 중"으로 표시됩니다. 무슨 뜻인가요?',
    faqIAccordion3Description:
      '이는 현재 저희 검토 인력이 학습자님의 시험 세션을 분석하고 있다는 뜻입니다. 검토 결과에 따라 학습자님의 시험은 대시보드에 "인증 완료" 또는 "인증 불가"로 표시됩니다.',
    faqIAccordion3Description2:
      '보안 검토가 완료되는 즉시 이메일로 알려 드립니다. 학습자님이 시험을 마친 이후 48시간 이내에 검토 과정을 완료하도록 최선을 다하겠습니다. 시험이 "인증 완료"로 표시되어 있다면 성적증명서를 열람, 다운로드하거나 원하는 기관에 직접 <bold>공유</bold>하실 수 있습니다.',
    formDownloadText:
      '시험에 응시하려면 사용하는 데스크톱에 <bold>English Skills Certificate 앱</bold>을 다운로드하셔야 합니다.',
    formDownloadClose: '닫기'
  },
  footerGetInTouchHeader: '고객 지원',
  footerGetInTouchText: '신뢰할 수 있는 상담사에게 지금 바로 문의하세요',
  footerGetInTouchButton: '문의하기',
  welcomePopup: {
    subtitle: '환영합니다',
    mainTitle: '{{productName}}에 오신 것을 환영합니다',
    title: '학습자님의 대시보드입니다. 성공적인 시험 응시를 위해 준비하세요.',
    button: '완료',
    takeATest: '시험 치르기'
  },
  signInPage: {
    haveAccount: '이미 계정을 만드신 것 같습니다.',
    enterPassword: '계속하려면 비밀번호를 입력하세요.'
  },
  scoreLookup: {
    lookup: '성적증명서 검색',
    description1: '성적증명서에 액세스하려면 아래 정보를 입력해 주세요. 문제가 있다면',
    description2: '지원 페이지를',
    description3: '방문하여 자세한 정보를 확인하세요.',
    name: '수험자 이름',
    required: '필수 필드입니다',
    org: '기관 이름',
    country: '국가(선택사항)',
    consent:
      '이 박스를 클릭함으로써 본인은 수험자로부터 성적증명서에 액세스할 수 있는 권한을 부여받았음을 확인합니다.',
    viewCertificate: '성적증명서 보기',
    byClickingOn: '이를 클릭함으로써',
    youAreAgreeing: '다음에 동의하게 됩니다',
    privacyPolicy: '개인정보처리방침',
    termisOfUse: '이용 약관',
    cookiePolicy: '쿠키 정책에 동의하게 됩니다',
    tooltip: '저희는 본 데이터를 내부 보고용으로만 사용합니다.',
    expiredDescription:
      '안타깝지만 링크가 만료되어 점수에 더 이상 액세스할 수 없습니다. 수험자에게 새 링크를 요청하시기 바랍니다.',
    supportLink: '문제가 있다면 <a>지원 페이지</a>를 방문하여 자세한 정보를 확인하세요.',
    expiredButton: '홈페이지로 돌아가기'
  },
  mins: ' 분',
  'No score': '점수 없음',
  toast: {
    somethingWentWrong: '이런! 문제가 발생했습니다. 다시 시도해 주세요'
  },
  mobileUploadId: {
    takeAPhoto: '신원 확인을 위해 신분증 사진을 촬영해 주세요',
    toBegin:
      '신분증을 조명이 잘 비추는 단색 표면 위에 올리고 프레임에 맞추세요. 프레임 내에 신분증을 놓았다면 사진을 촬영하세요.',
    takePicture: '사진 촬영',
    takeAPhotoBack:
      '신분증 전면의 사진을 제출해 주셔서 감사합니다. 신분증 후면 사진을 제출해야 하는 경우 빈 프레임을 클릭하세요.',
    frontAccepted: '신분증 전면이 촬영되었습니다',
    important: '중요',
    importantInfo:
      '카드형 신분증의 경우 신분증의 전면과 후면을 모두 제출하셔야 합니다. 여권의 경우 한 장의 이미지만 제출하시면 됩니다.',
    frontOfId: '신분증 전면',
    use: '사용하기',
    tryAgain: '다시 찍기',
    retry: '재시도',
    tapToContinue:
      '아래의 프레임을 클릭하여 신분증 후면을 제출하거나 "건너뛰기"를 눌러 계속하세요.',
    skip: '신분증 후면 건너뛰기',
    backCaptured: '신분증 후면이 촬영되었습니다',
    backOfId: '신분증 후면',
    sessionExpired: '세션이 만료되었습니다!',
    outOfTime: '컴퓨터의 {{productName}} 애플리케이션으로 돌아가 새 QR 코드를 생성하세요',
    done: '완료',
    allDone: '모두 마치셨습니다.',
    toContinue: '시험을 계속 진행하려면 컴퓨터의 {{productName}} 애플리케이션으로 돌아가세요',
    thanksForCompleting: '과정을 완료해 주셔서 감사합니다. 이제 창을 닫으셔도 됩니다.',
    photoDidntMeetRequirements: '사진이 요건을 충족하지 않습니다',
    pleaseTryAgain: '다시 시도해 주세요. 신분증 사진을 촬영할 때 다음 가이드라인에 유념하세요.',
    guidelines: '사진 가이드라인',
    cornersMissing: '모서리 누락됨',
    blurry: '초점이 맞지 않음',
    covered: '가림',
    clear: '또렷하고 디테일이 포함됨',
    lineUp: '신분증을 조명이 잘 비추는 단색 표면 위에 올리고 프레임에 맞추세요.',
    errorHeader: '대신 스마트폰 사용',
    errorDescription:
      '이 페이지는 웹브라우저에서 액세스할 수 없습니다. 신분증을 제출하려면 스마트폰을 사용해 QR 코드를 스캔하세요.',
    useQrCode: '휴대전화를 사용하여 위의 QR 코드를 스캔하고 계속 진행하세요.',
    alreadySubmittedTitle: '이미 신분증을 제출하셨습니다',
    alreadySubmittedDescription: '감사합니다, 여기에서는 필요한 모든 작업을 완료하셨습니다',
    linkOnlyValidFor:
      '모바일 기기로 신분증을 업로드할 수 있는 링크는 <bold>14일</bold> 동안 유효합니다. 추가 지원이 필요한 경우 <a>지원팀</a>에 문의하세요.',
    timeLeftToSubmit: '신분증 제출까지 남은 시간',
    linkNotValidAnymore: '이 링크는 더 이상 유효하지 않습니다'
  },
  skillsTile: {
    weWereUnable:
      '학습자님의 점수를 인증할 수 없습니다. 아래의 <bold>내 점수 보기</bold>를 클릭하여 점수 세부정보를 확인하세요.'
  },
  testTile: {
    weAreUnable:
      '이 시험은 완료되지 않았기 때문에 학습자님께 점수를 제공해 드릴 수 없습니다. 무료로 재시험에 응시하세요.',
    ifNeedHelp: '도움이 필요한 경우 <a>지원</a>팀에 문의하세요.',
    testId: '시험 ID',
    weCantProvide:
      '시험 규칙을 위반하셨기 때문에 시험 결과를 인증할 수 없습니다. 질문이 있다면 <a>지원</a>팀에 문의하세요.',
    dueToProblem:
      '죄송합니다. 저희 측 문제로 인하여 이 시험에 점수를 제공해 드릴 수 없습니다. 무료로 재시험에 응시하세요.'
  },
  certificateTypes: {
    readingWriting: 'English Certificate | 읽기 & 쓰기',
    speakingListening: 'English Certificate 말하기 & 듣기'
  },
  availableTestsNotification: '<a>{{testsCount}}개</a>의 시험을 이용하실 수 있습니다.',
  clickHereToSubmit: '여기를 클릭하여 신분증 후면을 제출하거나 "건너뛰기"를 눌러 계속 진행하세요.',
  webResultsSurvey: {
    certified: {
      upperTitle: '의견 공유하기',
      title: '시험 경험은 어떠셨나요?',
      subTitle: '성적증명서 획득을 축하드립니다! {{productName}} 이용 경험은 어떠셨나요?'
    },
    incomplete: {
      question1: {
        title: '시험 도중 무슨 일이 있었는지 알려주세요',
        option1: '더 이상 시험을 완료하고 싶지 않았다',
        option2: '기술적인 문제가 발생했다',
        option3: '기타(아래에 자세히 기술)'
      },
      question2: '공유하고 싶은 사항이 있으신가요?',
      question3: {
        title: '앞으로 5일 이내에 무료로 시험에 재응시하시겠어요?',
        option1: '예',
        option2: '아니요'
      }
    },
    uncertified: {
      subTitle:
        '안타깝지만 시험을 인증할 수 없습니다. 학습자님의 상황을 이해할 수 있도록 도와주세요.',
      scaleMinLabel: '전적으로 동의함',
      scaleMaxLabel: '전혀 동의하지 않음',
      q1: '내 시험이 인증되지 않은 이유를 이해했다',
      q2: '시험 환경을 개선하기 위해 무엇을 해야 할지 알겠다',
      q3: '시험에 재응시할 계획이다'
    },
    firstPurchase: {
      title: '결제 경험은 어떠셨나요?',
      subtitle: '시험을 접수 및 결제해 주셔서 감사합니다! 경험을 평가해 주세요.'
    }
  },
  limitReachedModal: {
    title: '한도 도달',
    close: '닫기'
  },
  policiesLinks: {
    termsOfUse: '이용 약관',
    privacyPolicy: '개인정보처리방침'
  },
  activationCodePopup: {
    expiredMessage: '활성화 코드가 만료되었습니다',
    title: '시험 활성화하기',
    subtitle: '시험 추가',
    description:
      '외부 공급업체를 통해 시험을 접수하신 경우 활성화 코드를 받으셨을 겁니다. 해당 코드를 이용해 언제든 시험을 활성화하실 수 있습니다. 일단 활성화되면 90일 이내에 시험에 응시하셔야 합니다.',
    inputPlaceholder: '활성화 코드',
    buttonText: '시험 활성화',
    tooltip:
      '<bold>활성화 코드를 찾을 수 없으신가요?</bold><br/> 이메일을 확인하거나 외부 공급업체에 문의하세요',
    skip: '건너뛰기',
    next: '다음',
    validMessage: '계정에서 시험을 찾으실 수 있습니다',
    invalidMessage: '유효하지 않은 활성화 코드입니다',
    usedMessage: '이미 사용된 활성화 코드입니다',
    tooManyAttempts: '이런! 너무 많이 시도하셨어요. 나중에 다시 시도해 주세요'
  },
  pageNotFound: {
    title: '이런! 갈 곳을 잃으신 것 같네요',
    description: '찾고 계신 페이지를 찾을 수 없습니다',
    button: '홈페이지로 돌아가기'
  },
  orderHistory: {
    testWasFree: '이 시험은 무료였으므로 환불받을 수 없습니다.',
    alreadyRefunded: '이 주문은 환불 처리되었습니다',
    testAlreadyRefunded: '이 시험은 환불 처리되었습니다'
  },
  downloadCertificatePopup: {
    wrapperTitle: '성적증명서 다운로드',
    subtitle: '아래에서 다운로드하려는 자료의 언어를 선택하세요.',
    buttonText: '다운로드',
    myTopScore: 'MYTOPSCORE',
    speakingListening: '말하기 & 듣기',
    readingWriting: '읽기 & 쓰기',
    languages: {
      eng: '영어',
      jpn: '일본어',
      kor: '한국어'
    }
  },
  sharedScoresDetailedTable: {
    headers: ['이름', '이메일', '공유일', '상태', '공유 중']
  },
  cefrScore: 'CEFR',
  oAuthFailed: {
    title: '죄송합니다. 계정이 존재하지 않습니다',
    subtitle:
      '입력한 이메일로 가입된 Versant English Certificate의 기존 계정이 없습니다. 계정을 만들려면 가입하세요.'
  },
  remove: '삭제'
};
